/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports.systemVar = {
  networkId: "nid",
  a: '',
  acceptDomains: ['m.vpon.com', 'tw-img.vpon.com'],
  adhesionPosition: 'vpon_ad_adhesion',
  ad_identifier: 'ad_identifier',
  ad_is_lat: 'ad_is_lat',
  ad_id_type: 'ad_id_type',
  adRequestCallBack: 'ad_request_callback',
  // branch:requestAdCallback
  adRotate: true,
  adUrlHeaderName: 'adURL',
  clickUrlHeaderName: 'clickURL',
  closeImgSrc: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2CAYAAACMRWrdAAAACXBIWXMAAAsTAAALEwEAmpwYAAAE+UlEQVR42uVazUsbQRQ3W5sGE1EiiB8YSkDSUy/eC9JDL+pdbP8DUQ8FFfXkR4p6VNv/wVu9eRFBKd6lor16q8ZThfo1nZ+8Ka/L7nxsNiZsBx4huzPvvd/OzPuaaRJCNCWR4mfY1JRi5Gnob7+GBcaUfCapWVJaUkZSi6SspByjLD3PUL9mGhcryDgA4es/J0WheF5Sl6Q+SUVJ/ZJKkl7Rbz8976N+eRqXIT5eHADjAJQl5Xqh9NjY2Nu9vb3y2dnZ1/Pz82+VSuXH9fV15f7+/ha/+I/neI9+6E9ge4lPNg6AUUB5tHywnDokvRwfH393dHT0+eLi4rvs8yDc2gPGYTz4gB/xbSE5Xk2BsT30QlK7pMLIyMib4+PjbcyGiKGBD/iBL/iTnBdqD8YOjIHCV+wslUqv5Rf+cnNz88uvnHwmdnd3xeTkpBgeHhYDAwOiu7tbpNPpx1/8x/OpqanHfugfwOMX+EMO5JFcJ3C2oJppg/dgT8ilc+JXZn9/X4yOjoq2tjYMsib0xziM9zfIoT3YQ/KbbcHZgmqFFVtbW3svDcBPLlwuHTE0NOQEJozAB/x4gzzIJSvaagvOZvnhS/Vtb29/vLu7+60E3t7eiomJCeF5XiygFIEfljH4qwa5kE/gcjbLUgdM7ame9fX1DxyUXCJicHAwVkB+An/I4eBo5nrUnnMGRiYd1qgTa5wvv9PTU1EsFmsKShHkQB5flrTnOkk/zxoY21ftsErcUOALPhUoDo7PHPQha9mu229hs4WpLsDk8j1V6+WnW5Z8z0Ev8nMtYbMWNFsIZzrgJLmfgqGoByhFkM/9HDnxDtI3ZQLmUaz2EhEAN+k665dKpYTc2OLy8lLMzs46KTw/Py9k/ChWVlaM1pK7AuhH4Vc2aNaCZiuPmI2HSTo/BVBbW1v/+J7l5WUrUOjH28bGhtHP8fCLYst80Kz5gSF16EVAyiMKnbByuRwY95nA+UGptrq6qh3HIxToSVlBRgdMOeN+bgkR7ugEYRmFtTBwYaDQrq6utPKgD7eQlPLk/H7Nb+Lz8BMq9UCAaor95ubmtBG7H5wOFJppj0IfFjg/kF/L+00/B4Y0vUsmf5/UKETfNntlaWnJCpwJlMmAKIJeqiFZpUw8HQYM67QgM9sdNQgxm611Myl9eHgYCygQ9FIN+pJPywQBU065iLRdDULe5GK6TeDiAAWCXqpBX6qh/OOs/f6rHzUJNQhJoasjdQXnCgoEvVSDvmRAsmHAYFlKKLioQch4o0QJtuCigAJBLxYYV6j6ldMBe8UdM9L5qCHQwcGBFhTeR+UNvbijptJeruYztri4aDVj6PcUMxbLHrMFVQ041z1WtVV0BRUVnItVVH6sDxXaKH7MBMrkx1zAoXTH/NhXqoVkTJFH2TXyMIFS1s/Uzxaca+QRKVacnp52MukmcIg9Y4sVq4nueT3C1k/pYktkCw7R/XdtdF9NPob8KYrzDQNnGhclH4uUQYM2NzcjRRR+cOATewZdTc0DBDBYRgsLC06me2Zm5rFWYsqcI9c8Gr1KxVMV5ypVYuuKia4EJ7Z2H3TaglOORJy21Pt8DHxrdj4WdKKJc7J6nGhCbmwnmok+g67lrQG8r+utgUTf83C4mXMS8WbOSd1u5jjepfqECq3hLtVOQ92lcrj9VjDcfis03O23xN9XTPwN0//iTnCj0B+EQvIvT23cBQAAAABJRU5ErkJggg==',
  cookieCTID: 'vpadn-ctid',
  connectQueue: [],
  contentData: 'content_data',
  coverPolicyCheckHeightBand: 0,
  coverPolicyCheckWidthBand: 0,
  debug: 'debug',
  format: 'vpon_ad_format',
  ///20210105: Attr of GAM TargetingMap
  gamTargetingMap: 'vpon_content_data',
  impUrlHeaderName: 'impURL',
  intCloseBtnEndureTime: 5000,
  intCloseBtnAppearTime: 3000,
  isGettingAd: true,
  isRotate: 'is_rotate',
  // branch:requestAdCallback
  landing: '',
  licensekey: 'vpon_ad_licensy_key',
  lower_bound_vpon_refresh_time_second: 15,
  openTab: 'openTab',
  pullFrameIndex: '_1',
  nativeAdLabel: 'Sponsored',
  nativeCoverMin: 'vpon_na_min',
  nativeLayoutOption: 'vpon_na_layout',
  rectHeightTotalBand: 5,
  rectWidthTotalBand: 5,
  reqAdFrameId: '',
  reqAdUrl: 'tw-api.vpadn.com/api/webAdReqV2',
  sdk: 'vpadn-sdk-w-v5.0.0',
  useCustomCloseCallBack: 'use_custom_close',
  useCustomCloseBtnId: 'use_custom_close_id',
  use_custom_z_index_int_30h: 'use_custom_z_index_int_30h',
  useHeightBand: 1,
  useWidthBand: 1,
  vponBannerTagCount: 3,
  vponIntTagCount: 1,
  vpon_refresh_time: 120000,
  vponTag: 'vpon',
  isUseCustomClose: false,
  referrerPolicy: 'no-referrer-when-downgrade',
  ariaLabel: {
    close_button: 'CloseButton',
    mute_icon: 'muteIcon',
    unmute_icon: 'unmuteIcon',
    ad_img: 'adImg',
    replay_button: 'replaybutton',
    video_view: 'videoView'
  },
  lat: 'lat',
  lon: 'lon',
  accurary: 'accurary',
  adChoiceUrl: 'https://m.vpon.com/ad-choice/vpon-ad-choice.html',
  adChoiceArrowImg: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAyMCAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggaWQ9IlZlY3RvciIgZD0iTTEwLjI4NzggMTguMTYxNkMxMC4wMjYxIDE4LjQyMjkgOS42NzE0NiAxOC41Njk3IDkuMzAxNjcgMTguNTY5N0M4LjkzMTg4IDE4LjU2OTcgOC41NzcyMSAxOC40MjI5IDguMzE1NTYgMTguMTYxNkwwLjQwODA5OSAxMC4yNTQxQzAuMTQ2NzggOS45OTI1IC0zLjkwNDI1ZS0wNyA5LjYzNzgyIC00LjA2NTg5ZS0wNyA5LjI2ODAzQy00LjIyNzUzZS0wNyA4Ljg5ODI0IDAuMTQ2NzggOC41NDM1NyAwLjQwODA5OSA4LjI4MTkzTDguMzE1NTYgMC4zNzQ0NjJDOC41ODAyNSAwLjEyODEwNSA4LjkzMDEzIC0wLjAwNjA1MDUgOS4yOTE2OCAwLjAwMDE5NjA1MUM5LjY1MzIyIDAuMDA2NDQwNjkgOS45OTgyNiAwLjE1MjYwMSAxMC4yNTQzIDAuNDA3OTUxQzEwLjUwOTYgMC42NjM5NzQgMTAuNjU1OCAxLjAwOTAyIDEwLjY2MiAxLjM3MDU2QzEwLjY2ODMgMS43MzIxIDEwLjUzNDEgMi4wODE5OSAxMC4yODc4IDIuMzQ2NjhMNC43NjE4NSA3Ljg3MjZMMTguNjA0NiA3Ljg3MjZDMTguOTc0NyA3Ljg3MjYgMTkuMzI5NiA4LjAxOTYyIDE5LjU5MTMgOC4yODEzMUMxOS44NTMgOC41NDMwMSAyMCA4Ljg5Nzk0IDIwIDkuMjY4MDNDMjAgOS42MzgxMiAxOS44NTMgOS45OTMwNiAxOS41OTEzIDEwLjI1NDhDMTkuMzI5NiAxMC41MTY0IDE4Ljk3NDcgMTAuNjYzNSAxOC42MDQ2IDEwLjY2MzVMNC43NjE4NSAxMC42NjM1TDEwLjI4NzggMTYuMTg5NEMxMC41NDkxIDE2LjQ1MSAxMC42OTU5IDE2LjgwNTcgMTAuNjk1OSAxNy4xNzU1QzEwLjY5NTkgMTcuNTQ1MyAxMC41NDkxIDE3LjkgMTAuMjg3OCAxOC4xNjE2WiIgZmlsbD0iIzQ0NDg1MCIvPgo8L3N2Zz4K',
  adChoiceImg: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI4LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IuWcluWxpF8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB2aWV3Qm94PSIwIDAgODUgODUiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDg1IDg1OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGw6IzQ0NDg1MDtmaWxsLW9wYWNpdHk6MC41O30KCS5zdDF7ZmlsbDpub25lO3N0cm9rZTojOUE5QTlBO3N0cm9rZS13aWR0aDo0LjI1MjtzdHJva2Utb3BhY2l0eTowLjU7fQoJLnN0MntmaWxsOiNGRkZGRkY7fQo8L3N0eWxlPgo8cGF0aCBjbGFzcz0ic3QwIiBkPSJNNDIuNSw4NUM2Niw4NSw4NSw2Niw4NSw0Mi41UzY2LDAsNDIuNSwwUzAsMTksMCw0Mi41UzE5LDg1LDQyLjUsODV6Ii8+CjxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik04Mi45LDQyLjVjMCwyMi4zLTE4LjEsNDAuNC00MC40LDQwLjRTMi4xLDY0LjgsMi4xLDQyLjVTMjAuMiwyLjEsNDIuNSwyLjFTODIuOSwyMC4yLDgyLjksNDIuNXoiLz4KPGc+Cgk8cGF0aCBjbGFzcz0ic3QyIiBkPSJNNDkuNiw1OC4yYy0wLjQtMC4yLTAuNy0wLjUtMS0wLjdjLTAuNS0wLjMtMS0wLjEtMS4zLDAuNGMtMC42LDEuMS0xLjUsMi42LTIuOSwzLjljLTEsMC45LTIuNi0wLjEtMi4zLTEuMwoJCWw3LjgtMjguOWMwLjItMC43LTAuNC0xLjItMS0xLjFsLTE0LjcsMi41Yy0wLjUsMC4xLTAuOSwwLjYtMC44LDFsMC4yLDEuNWMwLjEsMC41LDAuNSwwLjgsMC45LDAuOGgzLjZsLTcuMSwyNi4yCgkJYy0wLjEsMC43LTAuMywyLjMsMC41LDMuOWMxLjYsMyw1LjQsMy4yLDYsMy4yYzAuNSwwLDIuNCwwLjEsNS0xLjNjNC40LTIuNCw2LjUtNi40LDcuNS04LjhDNTAuMSw1OC44LDUwLDU4LjQsNDkuNiw1OC4yeiIvPgoJPHBhdGggY2xhc3M9InN0MiIgZD0iTTQ2LjMsMTIuOGMtMy41LDAtNi40LDIuOC02LjQsNi40YzAsMy41LDIuOCw2LjQsNi40LDYuNGMzLjUsMCw2LjQtMi44LDYuNC02LjQKCQlDNTIuNywxNS42LDQ5LjgsMTIuOCw0Ni4zLDEyLjh6Ii8+CjwvZz4KPC9zdmc+Cg=='
};
module.exports.apiConfig = {
  protocol: 'https:',
  hostname: 'tw-api.vpadn.com',
  path: {
    click: '/api/webviewAdClick/',
    request: '/api/webAdReqV2',
    videoEvent: '/api/webviewAdOnVideo'
  }
};
module.exports.parseUriOptions = {
  strictMode: false,
  key: ['source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'],
  q: {
    name: 'queryKey',
    parser: /(?:^|&)([^&=]*)=?([^&]*)/g
  },
  parser: {
    strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
    loose: /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/
  }
};
module.exports.nativeLayout = {
  0: {
    content: '<div class="vpon-native-ad" style="overflow:hidden; width :100%;"><div class="vpon-attribution">${ad_label}</div><div class="vpon-icon-image"><img></div><div class="vpon-title">${title}</div><div class="vpon-cover-image"><img></div><div class="vpon-body-text">${body}</div><div class="vpon-action">${action_name}</div></div>',
    imgNum: 2
  },
  1: {
    content: '<div class="vpon-native-ad" style="overflow:hidden; width :100%;"><div class="vpon-attribution">${ad_label}</div><div class="vpon-cover-image"><img></div><div class="vpon-title">${title}</div><div class="vpon-body-text">${body}</div><div class="vpon-action">${action_name}</div></div>',
    imgNum: 1
  },
  2: {
    content: '<div class="vpon-native-ad" style="overflow:hidden; width :100%;"><div class="vpon-attribution">${ad_label}</div><div class="vpon-title">${title}</div><div class="vpon-cover-image"><img></div><div class="vpon-body-text">${body}</div><div class="vpon-action">${action_name}</div></div>',
    imgNum: 1
  }
};
module.exports.VIDEO_EVENT_URL = 'https://tw-api.vpadn.com/api/webviewAdOnVideo';
module.exports.TPL_PARAMS = {
  ACTION: 'a',
  UID: 'uid',
  ADID: 'ad',
  AD_TYPE: 't',
  LICENSE_KEY: 'bid',
  VIDEO_TRACKING_ID: 'vid_tid',
  SDK: 'sdk',
  SESSION_ID: 'vpadnSid',
  SEQUENCE_ID: 'vpadnSeq',
  VIDEO_FUNCTION_1_DESC: 'v_f_1_des',
  PARAM_E: 'e',
  PROGRESS: 'progress',
  W_F_1_A: 'w_f_1_a'
};
module.exports.websdkParams = {
  licensekey: "vpon_ad_licensy_key",
  gamTargetingMap: 'vpon_content_data',
  contentData: 'content_data',
  format: "vpon_ad_format",
  vponAdTest: "vpon_ad_test",
  debug: "debug",
  adTest: "vpon_ad_test",
  adIdentifier: "ad_identifier",
  adIsLat: "ad_is_lat",
  useCustomClose: "use_custom_close",
  customClick: "vpon_custom_click",
  adRequestCallBack: "ad_request_callback",
  nativeCoverMin: 'vpon_na_min',
  nativeAdLabel: "Sponsored",
  openTab: "openTab",
  nativeLayoutOption: "vpon_na_layout",
  sdk: 'vpadn-sdk-w-v5.0.0',
  useCustomCloseCallBack: 'use_custom_close',
  apiConfig: {
    protocol: 'https://',
    hostname: 'tw-api.vpadn.com',
    path: {
      adRequest: '/api/webAdReqV2'
    }
  },
  previewConfig: {
    protocol: 'https://',
    hostname: 'creative-preview.vpadn.com',
    path: {
      previewRequest: '/web/creative/resource'
    }
  },
  apiPayload: {
    adRequest: {
      referrerPolicy: 'no-referrer-when-downgrade',
      credentials: 'include'
    }
  },
  adTypeArr: [{
    attribute: "320x50_mb",
    expectResult: "banner"
  }, {
    attribute: "320x100_mb",
    expectResult: "banner"
  }, {
    attribute: "300x250_mb",
    expectResult: "banner"
  }, {
    attribute: "320x480_mb",
    expectResult: "banner"
  }, {
    attribute: "mi",
    expectResult: "mi"
  }, {
    attribute: "na",
    expectResult: "na"
  }],
  adAmountLimit: {
    banner: 3,
    mi: 1
  },
  formatMapping: ["320x50_mb", "320x100_mb", "300x250_mb", "320x480_mb", "970x250_mb", "mi", "na"],
  regex: {
    licensekey: /^[A-Za-z0-9]{32}$/,
    ctid: /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/
  },
  vponTagAttrs: {
    format: "vpon_ad_format",
    licensekey: "vpon_ad_licensy_key"
  },
  cookie: {
    sid: 'Vpadn-Sid',
    ctid: 'vpadn-ctid',
    thirdCookieEnabledFlag: 'vpadn-ce',
    seid: 'vpadn-seid'
  },
  adUrlMapping: {
    ban_img: "vpadn-tpl-ban_w-v2.html",
    ban_vid: "vpadn-tpl-ban-vid_w.html",
    int_fit: "vpadn-tpl-int_w-v2.html",
    int_vid: "vpadn-tpl-int-vid_w-v2.html",
    int_30h: "vpadn-tpl-int-30h_w.html"
  },
  assets: {
    logo: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAuCAMAAABgZ9sFAAABQVBMVEU+Pj44ODg7OztVVVU1NTVMaXEzMzMqKiotLS0wMDAnJycrKytYWFhHR0dAQD85OjkoKicvLy0sLCxbW1syMDNQUFAODg4sLCw4ODZLS0smJiYyMTEVFRYQEBAjIyMhISERERFWVlYoKCgSEhL7+/tVVVUbHBsfHx9QUFA4Nzg0NDRTVFNRUFAZGRn9/f0YGBgWFhaampr5+fnz8/NRUVFOTk5bW1x0dHR6eXn29vYsLCza2tpMTExQUFDq6uqqqqrp6emvr683Nzfv7+87ODv39/fIx8fX19fd3d06Ozq/v7+OjY7u7u6WlpZOTk7MzMzR0dEZGRqCgoKhoaG3t7eNjY1GRkY9PT1QUFBFRUXi4uKmpqbS0tJXV1e+vr5gYGC2tra6urpFRUVQUFDm5uZVVVZvb28fHx9ubm6Dg4P///+MlWkJAAAAanRSTlNaWlqtWgBaWlpaWlqthlpaWlpcrVqGqWJahmtfkqJvdZ2tZpf8qX97ZV5bn5SD/oiMifjqc41ow3T2ruoeCdiS8dRp9lrvrb7HsqSA4M+45LasytKcyrRyRmDQquO74rze2YAp0K2VobazCebO3gAAAslJREFUeNq9kvdD2kAUx4meJCGOEGnAMMOQMCwOaB2g1tphl1VbtXuv9///Af3eXSIYKKW/9Mvx7o0Pl3cvRGb+SYN477LdaVSmx6mPd9uSnAjveRyuNDtzY+Xj3Sbg5oUV+4sk/qUxPd04QKheFVTumjFTjZkm95AwTVPgXdBzlspzJv+gAh4WX85BMe5JvIdOPqsTieOe+62jTox3K27Dmhxvu+6BoaqGoRmaqhmGikBDCRkRIUSaexrwXsVtalKGMCo3cLEHBqGsRmYuXfdCm1QR9FKxpO95NcsYwdQ9L22pPt656mWXym9yRStMr63TVs5JqhJvuB0/v0e0lVkuhh/whOhOacUxJF6ZXfLztXtEp5lc6PjHROWj7ErRb2Z2dkmPx+Pw4/eJdrLLybiGUBgdlYdEx3Ypb/FMgOtCt8pE7zKOIQKgQe6DvYokDyUeCCe9L1ST+oDwxH1b5oZw3ud2y9H6NL/PSzuT04ZxCFM4K+XT/QSf1gnuo4/EXxDdxRT6iV1M0S7lrEE8kYhGo7qe0BOv1oluZ1BNQIg3iego2ypqUT2BlRB4tK/nmGVhORmED4je2uguiMP45k2iZ6uOLiOPP8xGOBqHXhN9LFT94x75U4z+EV8jWt9uFcV5qQ2ip5hifDTOsASCblnwU0yR+4xhCfwGGxRvILuS5O5Xok/8ov3iMO6JWTp1xsS1McX6OJxheMe4HmN8qHYBh4/F+as5X3XqwRTrQ3iKKUxJpRhTFIUx/uLRMf9DnOCVoYqCXAJXrmsPAzlvtTGiM0yxPlAZiUcAlne2+BQxIuU6vgg8pLUyQfKPXgvji8DD/Aah8VMbnaeG8QWuKWmxHR6mDr7/+vmjkKkWa6KiwIqqwKeGtJB28tW8k1RC+dE4tFBLpxU8bAQeEZqSBhsWKjAyIXYB+/jE+k/4fGQeC5JbRH4GMiL8DVCuk0infmIEAAAAAElFTkSuQmCC",
    closeBtn: "data:image/png;base64,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",
    oneThirdCloseBtn: "data:image/png;base64,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",
    zoonBtn: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAAASFBMVEVMaXEAAAAAAAD///8AAAAAAAAAAAAAAAAAAAAAAAAAAAC/v79gYGDPz88QEBCAgIDt7e1AQEAwMDAgICBwcHCvr69QUFCPj48k3ENwAAAACnRSTlMA3yD/EEBQgO+fGxWR4AAAATBJREFUeNqt1tlyhSAMBuAqYCAuuJ3T93/TTi2SxsHEDv1vvOEbZAt8/FNaBz9x7aP2XfBI8aFT2lvI7UmB1cFz5Bq8S+OKAlAKFERAOUERuuFCN/o4pn4eruNx5ZbLsh3f0RhzGJeFbYpkNGbekjD9MddW+a3vlksSZmBTbb1AmEBvhU4SeTORu/ECmblAf4gOBZIEpRNXkQm2nl4hY4z7xv6sRYmkzJjT0sqLxLDBwB8JSCSSiAWipYqEyl6mV5+zPiPRUF4ScUXS3xL3e/X3R6Rle2yP8VMj/rqTp1Ejgc4LCZl06VRyMQvEp7PPxdALBM4KwwQKxFtWx04hEeDV8hT4pt1+SWN5Tc6VF9dlvVt5ClB9FwIV94tgKm++UH8j6/d+/euCIx3oL6X699gXXUtEJQBdBRkAAAAASUVORK5CYII='
  }
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var _require = __webpack_require__(2),
  isUrl = _require.isUrl,
  checkAdType = _require.checkAdType,
  verifyCtid = _require.verifyCtid;
var _require2 = __webpack_require__(0),
  websdkParams = _require2.websdkParams;
var _require3 = __webpack_require__(2),
  cookieParamsValidator = _require3.cookieParamsValidator;
var _require4 = __webpack_require__(5),
  getTopReachableDomain = _require4.getTopReachableDomain;
var checkCookieNameIsExist = function checkCookieNameIsExist(name) {
  return document.cookie.split(";").some(function (item) {
    return item.trim().startsWith("".concat(name, "="));
  });
};
var getCookieOfObject = function getCookieOfObject() {
  return document.cookie.split(";").map(function (item) {
    return item.trim().split("=");
  }).reduce(function (prev, curr) {
    var _curr = _slicedToArray(curr, 2),
      key = _curr[0],
      value = _curr[1];
    return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, key, value));
  }, {});
};

/**
 * 211027>
 * Add Hinet third party tracking one in ten. The one is determined by ctid.
 */
//const initialHinet = () => {
//  try {
//    const CTID_NAME = "vpadn-ctid";
//    if (
//      checkCookieNameIsExist(CTID_NAME) ||
//      (window.localStorage && window.localStorage.getItem(CTID_NAME))
//    ) {
//      const getCookie = getCookieOfObject();
//      const ctidCookie = getCookie[CTID_NAME].split("_")[1].split(".")[0];
//      const CTID =
//        ctidCookie ||
//        (window.localStorage && window.localStorage.getItem(CTID_NAME));
//      if (Math.random() <= 0.3) {
//        const script = document.createElement("script");
//        script.async = true;
//        script.src = "https://t.ssp.hinet.net/utag.js";
//        document.getElementsByTagName("head")[0].appendChild(script);
//
//        script.onload = () => {
//          var partnerId = "7f1e29";
//          window.__hitagCmdQueue = window.__hitagCmdQueue || [];
//          function hiball() {
//            __hitagCmdQueue.push(arguments);
//          }
//          hiball("fire", partnerId);
//          hiball("cm", partnerId, `${CTID}`);
//        };
//      }
//    } else {
//      console.warn(
//        "[web-sdk] initialHinet: There is not vpadn-ctid in cookie or local storage."
//      );
//    }
//  } catch (error) {
//    console.error(`[web-sdk] initialHinet something wrong: ${error}`);
//  }
//};

//const initialEland = () => {
//  const script = document.createElement("script");
//  script.async = true;
//  script.src = "https://dmp.eland-tech.com/dmpreceiver/eland_tracker.js";
//  document.getElementsByTagName("head")[0].appendChild(script);
//  script.onload = () => {
//    if (checkCookieNameIsExist("vpadn-ctid")) {
//      const getCookie = getCookieOfObject();
//      const ctid = getCookie["vpadn-ctid"].split("_")[1].split(".")[0];
//      const dataJson = {
//        source: "VPON",
//        trackType: "view",
//        targetType: "usual",
//        trackSubfolderDepth: 1,
//        ecInfo: {
//          memberID: ctid,
//        },
//      };
//      ElandTracker.Track(dataJson);
//    }
//  };
//};

var endsWith = function endsWith(str, suffix) {
  return str.indexOf(suffix, str.length - suffix.length) !== -1;
};
var s4 = function s4() {
  return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
};
var genGuid = function genGuid() {
  return s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4() + s4();
};
var getCookie = function getCookie(c_name) {
  var c_value = document.cookie;
  var c_start = c_value.indexOf(" " + c_name + "=");
  if (c_start == -1) {
    c_start = c_value.indexOf(c_name + "=");
  }
  if (c_start == -1) {
    c_value = null;
  } else {
    c_start = c_value.indexOf("=", c_start) + 1;
    var c_end = c_value.indexOf(";", c_start);
    if (c_end == -1) {
      c_end = c_value.length;
    }
    c_value = unescape(c_value.substring(c_start, c_end));
  }
  return c_value;
};

/* remove for CNA publisher, possibly cause is function name conflict
function setCookie(c_name,value,exdays){
  var exdate=new Date();
  exdate.setDate(exdate.getDate() + exdays);
  var c_value=escape(value) + ((exdays==null) ? "" : "; expires="+exdate.toUTCString());
  document.cookie=c_name + "=" + c_value;
}
*/

var uaMatch = function uaMatch(substr) {
  return (window.navigator ? window.navigator.userAgent : "").indexOf(substr) != -1;
};
var isSDKiOS = function isSDKiOS() {
  return uaMatch("(iPad") || uaMatch("(iPod") || uaMatch("(iPhone");
};
var isIPhone = function isIPhone() {
  return uaMatch("(iPhone");
};
var isSDKiOSNotIPhone = function isSDKiOSNotIPhone() {
  return uaMatch("(iPad") || uaMatch("(iPod");
};
var parseParamsFromUrl = function parseParamsFromUrl(url) {
  var params = {};
  var key = "";
  var value = "";
  if (url.indexOf("?") != -1) {
    var ary = url.split("?")[1].split("&");
    for (var i in ary) {
      key = ary[i].split("=")[0];
      value = ary[i].split("=")[1];
      // replace sms body content
      if (value.indexOf("sms%3A") > -1 && value.indexOf("%3Fbody%3D") > -1) {
        value = replaceSMSContent(value);
      }
      // use %20 for encoded character of white space instead of ‘+’
      // replace '+' with '%20' form any content include '+'
      else if (value.indexOf("+") > -1) {
        value = value.replace(/\+/g, "%20");
      }
      value = decodeURIComponent(value);
      // replace '\r\n' for sms
      if (value.indexOf("\r\n") > -1 && value.indexOf("sms:") > -1) {
        value = value.replace(/\r\n/g, "\\n");
      }
      params[key] = value;
    }
  }
  return params;
};
var regexp_replace = function regexp_replace(input, tagBeingReplaced, replaceWith) {
  var regex = new RegExp("\\$\\{" + tagBeingReplaced + "\\}", "g");
  return input.replace(regex, replaceWith);
};
var parseCtidToObj = function parseCtidToObj(ctid_dob) {
  try {
    if (ctid_dob === null || ctid_dob === undefined) {
      return {
        ctid: null,
        timestamp: null
      };
    }
    if (ctid_dob.split(".").length === 2) {
      var version = ctid_dob.split("_")[0];
      var ctid = ctid_dob.split("_")[1].split(".")[0];
      var timestamp = ctid_dob.split(".")[1];
      // 防止 cookie 還存在，但 localStorage 被清掉的情況，故再做一次儲存
      window.localStorage && window.localStorage.setItem("vpadn-ctid", "".concat(version, "_").concat(ctid, ".").concat(timestamp));
      return {
        version: version,
        ctid: ctid,
        timestamp: timestamp
      };
    } else {
      return {
        ctid: ctid_dob,
        timestamp: null
      };
    }
  } catch (error) {
    console.log(error);
  }
};

/**
 * fadeIn effect
 * @param {Object} el target element
 * @param {Number} ms transition duration
 * @param {Function} callback when transitionend event triggerd, execute callback function
 */
var fadeLock = null;
var fadeForFlrec = function fadeForFlrec(el) {
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "in";
  var ms = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;
  var callback = arguments.length > 3 ? arguments[3] : undefined;
  try {
    var transitionendCallback = function transitionendCallback() {
      console.log("transitionendCallback");
      clearTimeout(fadeLock);
      el.removeEventListener("transitionend", transitionendCallback);
      callback();
    };
    console.log("action:" + action);
    if (action === "out") {
      clearTimeout(fadeLock);
      el.removeEventListener("transitionend", transitionendCallback);
      return;
    }
    if (action === "in") {
      ms = !isNaN(parseFloat(ms)) ? parseFloat(ms) : 3;
      el.style.opacity = 0;
      setTimeout(function () {
        el.style.transition = "opacity ".concat(ms, "s");
        el.style.opacity = 1;
      }, 1);
      if (typeof callback === "function") {
        fadeLock = setTimeout(function () {
          console.log("fadeLock");
          clearTimeout(fadeLock);
          el.removeEventListener("transitionend", transitionendCallback);
          callback();
        }, ms * 1000 + 500);
        el.addEventListener("transitionend", transitionendCallback);
      }
    }
  } catch (err) {
    console.warn(err);
  }
};
var fading = null;
var fade = function fade(el) {
  var ms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "in";
  if (fading) {
    clearInterval(fading);
  }
  /**
   * return if close button was defined as display == none
   */
  if (el.style.display === "none") {
    return;
  }
  if (ms === 0) {
    el.style.display = "block";
    el.style.opacity = 1;
    return;
  }
  var isIn = type === "in";
  var opacity = isIn ? 0 : 1;
  var interval = 50;
  var duration = ms * 1000;
  if (duration === 0) duration = 0.1;
  var gap = interval / duration;
  if (isIn) {
    el.style.display = "block";
    el.style.opacity = opacity;
  }
  var func = function func() {
    opacity = isIn ? opacity + gap : opacity - gap;
    if (opacity <= 0) {
      clearInterval(fading);
      opacity = 0;
      el.style.display = "none";
    }
    if (opacity >= 1) {
      clearInterval(fading);
      opacity = 1;
    }
    el.style.opacity = opacity;
  };
  fading = setInterval(func, interval);
};
var getParams = function getParams() {
  var setLocation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : location.href;
  var url = new URL(setLocation);
  var params = {};
  var paramsArr = url.search ? url.search.replace(/^\?/, "").split("&") : [];
  var value = "";
  var _iterator = _createForOfIteratorHelper(paramsArr),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var key = _step.value;
      if (key) {
        value = key.split("=");
        params[value[0]] = value[1];
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return params;
};
var calculateViewRate = function calculateViewRate(target) {
  if (!target || !("getBoundingClientRect" in target)) {
    return;
  }
  var boundingRect = findFrameAbsoluteRect(target);
  var counter = 0;
  for (var i = 0; i <= 10; i++) {
    var position = {
      x: boundingRect.x + boundingRect.width / 2,
      y: boundingRect.y + boundingRect.height * i / 10
    };
    if (window.top.document.elementFromPoint(position.x, position.y) === target) {
      counter++;
    }
  }
  return {
    viewPercent: (counter - 1) / 10
  };
};
function isElementInsideContainer(container, target) {
  if (!container || !target) {
    return false;
  }
  if (container === target) {
    return true;
  }
  var iframes = [];
  if (container.tagName !== "IFRAME") {
    if (container.contains(target)) {
      return true;
    }
    iframes = _toConsumableArray(container.querySelectorAll("iframe"));
  } else {
    if (!container.contentDocument) {
      return false;
    }
    if (container.contentDocument.contains(target)) {
      return true;
    }
    iframes = _toConsumableArray(container.contentDocument.querySelectorAll("iframe"));
  }
  if (!iframes.length) {
    return false;
  }
  return iframes.some(function (iframe) {
    return _isElementInsideContainer(iframe, target);
  });
}
function _isElementInsideContainer(iframe, target) {
  if (!iframe.contentDocument) {
    return false;
  }
  if (iframe.contentDocument.contains(target)) {
    return true;
  }
  var iframes = _toConsumableArray(container.contentDocument.querySelectorAll("iframe"));
  if (!iframes.length) {
    return false;
  }
  return iframes.some(function (iframe) {
    return _isElementInsideContainer(iframe, target);
  });
}
function findFrameAbsoluteRect(element) {
  var currentWindow = window;
  var currentParentWindow;
  var positions = [];
  var rect = element ? element.getBoundingClientRect() : document.body.getBoundingClientRect();
  while (currentWindow !== window.top) {
    currentParentWindow = currentWindow.parent;
    var _iterator2 = _createForOfIteratorHelper(currentParentWindow.document.getElementsByTagName("iframe")),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var frameElement = _step2.value;
        if (frameElement.contentWindow === currentWindow) {
          var frameRect = frameElement.getBoundingClientRect();
          positions.push({
            x: frameRect.x,
            y: frameRect.y
          });
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    currentWindow = currentParentWindow;
    break;
  }
  positions = positions.reduce(function (accumulator, currentValue) {
    return {
      x: accumulator.x + currentValue.x,
      y: accumulator.y + currentValue.y
    };
  }, {
    x: rect.x,
    y: rect.y
  });
  return {
    x: positions.x,
    y: positions.y,
    top: rect.top,
    bottom: rect.bottom,
    left: rect.left,
    right: rect.right,
    width: rect.width,
    height: rect.height
  };
}

/**
 * get root domain(ex:.vpon.com)
 * @param {Object} location location object
 * @returns root domain string
 */
var getRootDomain = function getRootDomain() {
  var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location;
  if (!isUrl(location.href)) {
    return;
  }
  var hostname = location.hostname;
  var hostStringArray = hostname.split(".");

  //If the hostname has at least two parts, return the last two parts
  if (hostStringArray.length >= 2) {
    return hostStringArray[hostStringArray.length - 2] + "." + hostStringArray[hostStringArray.length - 1];
  }

  //Otherwise, return entrire hostname
  return hostname;
};

/**
 * UID generator
 * @returns generation UID
 */
function generateUID() {
  if (crypto && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  var S4 = function S4() {
    return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
  };
  return S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4();
}

/**
 * handle request ad parameters
 * @param {object} vponTag vpon tag
 * @returns request parameters
 */
var getReqAdParameters = function getReqAdParameters(vponTag) {
  var reqParameters = {};
  var adType = checkAdType(vponTag);
  if (adType == "na") {
    reqParameters.cover_min = vponTag.getAttribute(websdkParams.nativeCoverMin) || "";
  }
  reqParameters.format = vponTag.getAttribute(websdkParams.format);
  reqParameters.sdk = websdkParams.sdk;
  reqParameters.bid = vponTag.getAttribute(websdkParams.licensekey);
  reqParameters.adtest = vponTag.getAttribute(websdkParams.adTest) == 1 ? 1 : 0;
  reqParameters.adRequestCallBack = vponTag.getAttribute(websdkParams.adRequestCallBack);
  reqParameters.isRotate = vponTag.getAttribute(websdkParams.isRotate) || "true";
  reqParameters.s_h = document.documentElement.clientHeight;
  reqParameters.s_w = document.documentElement.clientWidth;
  return reqParameters;
};

/**
 * Adder
 * @param {*} initialValue adder initial value
 * @returns {number} result value.
 */
function adder() {
  var initialValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var value = initialValue;
  return function () {
    var num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    value += num;
    return value;
  };
}
var CTID = "";
function getCTID() {
  return CTID;
}

/**
 * Prepare context for ad request(cookie & localStorage)
 * vpadn-ctid: ad request url query
 * vpadn-vpid: 3rd party cookie
 */
function prepareContextForAdRequest() {
  var getCookieByKey = vpadnCookieComponent.getCookieByKey,
    setCookie = vpadnCookieComponent.setCookie,
    idsService = vpadnCookieComponent.idsService;
  var cookieDomain = getTopReachableDomain();
  var CTID;

  // Ensure that the localStorage.getItem method exists.
  if (window.localStorage && typeof window.localStorage.getItem === 'function') {
    CTID = getCookieByKey(websdkParams.cookie.ctid) || window.localStorage.getItem(websdkParams.cookie.ctid) || generateUID();
  } else {
    CTID = getCookieByKey(websdkParams.cookie.ctid) || generateUID();
  }
  if (verifyCtid(CTID)) {
    CTID = "v1_".concat(CTID, ".").concat(new Date().getTime());
  }
  if (window.localStorage) {
    window.localStorage.setItem(websdkParams.cookie.ctid, CTID);
  }
  var options = {
    path: "/",
    "max-age": 63072000,
    //two years
    domain: cookieDomain
  };
  setCookie(websdkParams.cookie.ctid, CTID, options);
  var seid = getCookieByKey(websdkParams.cookie.seid);
  var key;
  if (!seid || getTopReachableDomain(document.referrer) !== cookieDomain || !new RegExp("^" + key).test(seid)) {
    seid = "".concat(key, "-").concat(Math.floor(1 * new Date() / 100));
    var _options = {
      path: "/",
      "max-age": 1800,
      // 30 mins
      domain: cookieDomain
    };
    setCookie(websdkParams.cookie.seid, seid, _options);
  }
  if (getCookieByKey(websdkParams.cookie.thirdCookieEnabledFlag) !== "0" && getCookieByKey(websdkParams.cookie.thirdCookieEnabledFlag) !== "1") {
    var ctidObj = parseCtidToObj(CTID);
    var ctid = ctidObj.ctid;
    idsService(cookieDomain, ctid);
  }
}

/**
 * Vpadn cookie component, Used for get cookie by key and set cookie
 * @param {string} key cookie name
 * @param {string} value cookie value
 * @param {object} options cookie setting options
 */
var vpadnCookieComponent = {
  idsService: function idsService(cookieDomain, ctid) {
    var _location = location,
      protocol = _location.protocol;
    var beaconUrl = "".concat(protocol, "//ids-dmp.vpadn.com/set?t=").concat(1 * new Date(), "&dn=").concat(encodeURIComponent(cookieDomain), "&ctid=").concat(ctid);
    sendBeaconAjax(beaconUrl, SetHelper.setCallback, SetHelper.setErrorCallback);
  },
  getCookieByKey: function getCookieByKey(key) {
    var isValid = cookieParamsValidator({
      key: key
    });
    if (!isValid) {
      return;
    }
    var cookies = document.cookie;
    var cookiesArr = cookies.split(";").map(function (item) {
      return item.trim();
    });
    var targetCookie = cookiesArr.find(function (cookie) {
      return cookie.split("=")[0] === key;
    });
    if (!targetCookie) {
      console.warn("[Vpon-WebSDK] Can't find key => ".concat(key, "!"));
      return;
    }
    return targetCookie.split("=")[1];
  },
  setCookie: function setCookie(key, value, options) {
    var isValid = cookieParamsValidator({
      key: key,
      value: value,
      options: options
    });
    if (!isValid) {
      return;
    }
    var cookieString = generateCookieString(key, value, options);
    document.cookie = cookieString;
  }
};
var generateCookieString = function generateCookieString(key, value, options) {
  var cookieString = "".concat(key, "=").concat(value);
  Object.keys(options).forEach(function (key) {
    if (options[key] !== "secure") {
      cookieString += ";".concat(key, "=").concat(options[key]);
      return;
    }
    cookieString += ";secure";
  });
  return cookieString;
};
var sendBeaconAjax = function sendBeaconAjax(url, cb, errorCb) {
  var xmlHttp = new XMLHttpRequest();
  xmlHttp.timeout = 10000;
  xmlHttp.withCredentials = true;
  xmlHttp.onreadystatechange = function () {
    if (xmlHttp.readyState === 4 && xmlHttp.status === 200 && cb !== undefined) {
      cb(xmlHttp.responseText);
    } else if (xmlHttp.readyState === 4 && errorCb !== undefined) {
      errorCb(xmlHttp.responseText);
    }
  };
  xmlHttp.open("GET", url, true); // true for asynchronous
  xmlHttp.send();
};
var cookie = {
  write: function write(name, value, days, domain, path) {
    var date = new Date();
    days = days || 730; // two years
    path = path || "/";
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    var expires = "; expires=" + date.toGMTString();
    var cookieValue = "".concat(name, "=").concat(value).concat(expires, "; path=").concat(path, "; SameSite=None; Secure");
    if (domain) {
      cookieValue += "; domain=" + domain;
    }
    document.cookie = cookieValue;
  },
  read: function read(name) {
    var allCookie = "" + document.cookie;
    var index = allCookie.indexOf(name);
    if (name === undefined || name === "" || index === -1) return "";
    var ind1 = allCookie.indexOf(";", index);
    if (ind1 == -1) ind1 = allCookie.length;
    return unescape(allCookie.substring(index + name.length + 1, ind1));
  },
  remove: function remove(name) {
    if (this.read(name)) {
      this.write(name, "", -1, "/");
    }
  }
};
var SetHelper = {
  setCallback: function setCallback(e) {
    var json = JSON.parse(e);
    var JSON_KEY = "vponId";
    var THIRD_COOKIE_ENABLED_FLAG = "vpadn-ce";
    var JSON_THIRDPARTY_KEY = "ce";
    var COOKIE_LIFE_DAY = 7;
    var COOKIE_DOMAIN = getTopReachableDomain();
    if (json !== undefined && json[JSON_KEY] !== undefined) {
      // if (json[JSON_KEY] !== '0') {
      //     cookie.write(VPID_KEY, json[JSON_KEY], COOKIE_LIFE_DAY, COOKIE_DOMAIN);
      // }

      //if 3rd cookie setting failed, set a flag in 1st party cookie
      cookie.write(THIRD_COOKIE_ENABLED_FLAG, json[JSON_THIRDPARTY_KEY], COOKIE_LIFE_DAY, COOKIE_DOMAIN);
    }
  },
  setErrorCallback: function setErrorCallback(e) {}
};

/**
 * Initialize third party vender
 */
//function initialThirdPartyVendor() {
//  initialEland();
//  initialHinet();
//}

var checkInput = function checkInput(vponTag) {
  var result = {
    errMsg: "",
    adhesionPosition: false
  };
  var licensekey = vponTag.getAttribute(systemVar.licensekey);
  if (!checkAttributeIsGiven(licensekey)) {
    result.errMsg += "input licensekey is empty. ";
  }
  var regex = /^[A-Za-z0-9]{32}$/;
  if (!regex.test(licensekey)) {
    result.errMsg += "input licensekey error length. ";
  }
  result.adType = checkAdType(vponTag);
  var adhesionPosition = vponTag.getAttribute(systemVar.adhesionPosition);
  if (adhesionPosition) {
    if (adhesionPosition === "top") {
      result.adhesionPosition = "top";
    } else if (adhesionPosition === "bottom") {
      result.adhesionPosition = "bottom";
    } else {
      result.adhesionPosition = "unknown";
    }
  } else {
    result.adhesionPosition = false;
  }
  return result;
};
var initialIntIframeHtmlTag = function initialIntIframeHtmlTag(vponTag, guid) {
  var iframeId = guid + "_int_1";
  var iframe = document.createElement("IFRAME");
  iframe.style.width = "100%";
  iframe.style.height = "100%";
  iframe.setAttribute("id", iframeId);
  iframe.setAttribute("scrolling", "no");
  iframe.frameBorder = 0;
  var container = initialCloseButtonContainer(vponTag, iframeId, "int");
  var closeBtn = initialIntCloseButton(vponTag, iframeId);
  container.appendChild(closeBtn);
  container.appendChild(iframe);
  vponTag.appendChild(container);
};

/**
 * Todo: When ad response component refactoring in the
 * future, Move this function to ad response phase.
 * Create intistitial ad iframe, Contains the following two results.
 * 0: Some problem happen
 * 1: Success
 * @param {element} vponTag vpon tag node
 * @returns {number} result
 */
var vpon_ad_create_int_iframe = function vpon_ad_create_int_iframe(vponTag) {
  // check if vpontag already generate ad(iframes)
  if (vponTag.querySelectorAll("iframe").length > 0) {
    console.info("ERROR: ad(iframes) had exists inside vpontag, will not generate ad(iframes) again.");
    return 0;
  }

  // check vpon tag attribute
  var checkInputResult = checkInput(vponTag);
  if (checkInputResult.errMsg) {
    var debugMode = vponTag.getAttribute(systemVar.debug);
    if (debugMode) {
      console.info("ERROR: vpon tag fill attribute error, message => " + checkInputResult.errMsg);
    }
    return 0;
  }
  if (vponTag.getAttribute("status") == null) {
    vponTag.setAttribute("status", "1");
  } else {
    return 0;
  }
  var licenseKey = vponTag.getAttribute(systemVar.licensekey);
  var guid = licenseKey + "_" + generateUID();

  // initial iframe html tag
  initialIntIframeHtmlTag(vponTag, guid);
  return 1;
};

/**
 * Handle ad request url with ad request parameters.
 * @param {object} reqAdParameters ad request parameters
 * @returns {object} ad request url object
 */
function handleAdReqUrl(reqAdParameters) {
  var apiConfig = websdkParams.apiConfig;
  var adReqUrl = new URL("".concat(apiConfig.protocol).concat(apiConfig.hostname).concat(apiConfig.path.adRequest));
  Object.keys(reqAdParameters).forEach(function (key) {
    adReqUrl.searchParams.append(key, encodeURIComponent(reqAdParameters[key]));
  });
  return adReqUrl;
}

// ------------- function ------------

module.exports = {
  endsWith: endsWith,
  s4: s4,
  genGuid: genGuid,
  getCookie: getCookie,
  uaMatch: uaMatch,
  isSDKiOS: isSDKiOS,
  isIPhone: isIPhone,
  isSDKiOSNotIPhone: isSDKiOSNotIPhone,
  parseParamsFromUrl: parseParamsFromUrl,
  regexp_replace: regexp_replace,
  parseCtidToObj: parseCtidToObj,
  //  initialHinet,
  //  initialEland,
  fade: fade,
  fading: fading,
  fadeLock: fadeLock,
  fadeForFlrec: fadeForFlrec,
  getParams: getParams,
  calculateViewRate: calculateViewRate,
  generateUID: generateUID,
  getRootDomain: getRootDomain,
  getReqAdParameters: getReqAdParameters,
  adder: adder,
  prepareContextForAdRequest: prepareContextForAdRequest,
  vpadnCookieComponent: vpadnCookieComponent,
  //  initialThirdPartyVendor,
  vpon_ad_create_int_iframe: vpon_ad_create_int_iframe,
  handleAdReqUrl: handleAdReqUrl,
  getCTID: getCTID
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var _require = __webpack_require__(0),
  systemVar = _require.systemVar,
  apiConfig = _require.apiConfig,
  websdkParams = _require.websdkParams;
var divide = function divide(length, bandCount) {
  var res = [];
  for (var i = 0; i <= bandCount; i++) {
    res[i] = length / bandCount * i;
  }
  return res;
};
var coveredBannerCheck = function coveredBannerCheck(frame_id, vponTag) {
  // iframe is display:none or visibity:hidden
  if (!iframeViewable(frame_id)) {
    return false;
  }
  if (!isInCrossDomain()) {
    // iframe should be under the viewport. check the left and top will be inisde in the viewport.
    if (!underViewport(frame_id, vponTag)) {
      return false;
    }

    // iframe should be displayed fully in viewport
    // the viewport should completely contain the right and bottom of iframe
    if (!displayInViewport(frame_id, vponTag)) {
      return false;
    }
  }
  return true;
};
var iframeViewable = function iframeViewable(frame_id) {
  var myframe = document.getElementById(frame_id);
  // check display:none
  var displayStatus = myframe.style.display;
  if (displayStatus.toLowerCase() == 'none') {
    return false;
  }
  // check visibility:hidden
  var visibilityStatus = myframe.style.visibility;
  if (visibilityStatus.toLowerCase() == 'hidden') {
    return false;
  }
  return true;
};
var underViewport = function underViewport(frame_id, vponTag) {
  var myframe = document.getElementById(frame_id);
  var rect = myframe.getBoundingClientRect();
  var rectTop = getTransferRectHeight(rect.top, vponTag, '+');
  var rectLeft = getTransferRectWidth(rect.left, vponTag, '+');
  var frameBoundingClientRect = {
    fTop: 0,
    fLeft: 0
  };
  frameBoundingClientRect = getFrameBoundingClientRect(window, frameBoundingClientRect);
  rectTop = frameBoundingClientRect.fTop + rectTop;
  rectLeft = frameBoundingClientRect.fLeft + rectLeft;
  return rectTop >= 0 && rectLeft >= 0;
};
var displayInViewport = function displayInViewport(frame_id, vponTag) {
  var myframe = document.getElementById(frame_id);
  var rect = myframe.getBoundingClientRect();
  var rectBottom = getTransferRectHeight(rect.bottom, vponTag, '-');
  var rectRight = getTransferRectWidth(rect.right, vponTag, '-');
  var flag1 = window.innerHeight - rectBottom >= 0 && window.innerWidth - rectRight >= 0;
  if (window == top) {
    return flag1;
  } else if (flag1) {
    // in iframe
    var frameBoundingClientRect = {
      fTop: 0,
      fLeft: 0
    };
    var frameBoundingClientRect = getFrameBoundingClientRect(window, frameBoundingClientRect);
    rectBottom = frameBoundingClientRect.fTop + rectBottom;
    rectRight = frameBoundingClientRect.fLeft + rectRight;
    var flag2 = window.top.innerHeight - rectBottom >= 0 && window.top.innerWidth - rectRight >= 0;
    return flag2;
  } else {
    return false;
  }
};
var getFrameBoundingClientRect = function getFrameBoundingClientRect(nowFrame, frameBoundingClientRect) {
  if (nowFrame == top) {
    return frameBoundingClientRect;
  } else {
    frameBoundingClientRect = calIframeBoundingClientRect(nowFrame.parent.document, nowFrame.document, frameBoundingClientRect);
    return getFrameBoundingClientRect(nowFrame.parent, frameBoundingClientRect);
  }
};
var calIframeBoundingClientRect = function calIframeBoundingClientRect(frameDocument, nowDocument, frameBoundingClientRect) {
  var ifs = frameDocument.getElementsByTagName('iframe');
  // var isSafeFrame = /safeframe/;
  if (ifs) {
    for (var i = 0, len = ifs.length; i < len; i++) {
      try {
        var f = ifs[i].contentWindow.document || ifs[i].contentDocument;
      } catch (e) {
        continue;
      }
      var f = ifs[i];
      var fDoc = f.contentDocument || f.contentWindow.document;
      if (fDoc === nowDocument) {
        var rect = f.getBoundingClientRect();
        frameBoundingClientRect.fTop = frameBoundingClientRect.fTop + rect.top;
        frameBoundingClientRect.fLeft = frameBoundingClientRect.fLeft + rect.left;
        return frameBoundingClientRect;
      }
    }
  } else {
    return frameBoundingClientRect;
  }
};
function currentFrameAbsolutePosition() {
  var currentWindow = window;
  var currentParentWindow;
  var positions = [];
  var rect;
  while (currentWindow !== window.top) {
    currentParentWindow = currentWindow.parent;
    for (var idx = 0; idx < currentParentWindow.frames.length; idx++) if (currentParentWindow.frames[idx] === currentWindow) {
      var _iterator = _createForOfIteratorHelper(currentParentWindow.document.getElementsByTagName('iframe')),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var frameElement = _step.value;
          if (frameElement.contentWindow === currentWindow) {
            rect = frameElement.getBoundingClientRect();
            positions.push({
              x: rect.x,
              y: rect.y
            });
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      currentWindow = currentParentWindow;
      break;
    }
  }
  return positions.reduce(function (accumulator, currentValue) {
    return {
      x: accumulator.x + currentValue.x,
      y: accumulator.y + currentValue.y
    };
  }, {
    x: 0,
    y: 0
  });
}
var coveredIntCheck = function coveredIntCheck(frame_id) {
  var iframeTag = document.getElementById(frame_id);
  var rectWidthBand = divide(document.documentElement.clientWidth - 1, systemVar.rectWidthTotalBand);
  var rectHeightBand = divide(document.documentElement.clientHeight - 1, systemVar.rectHeightTotalBand);
  var notPass = 0; // count how many point wont pass
  var threshold = (systemVar.rectWidthTotalBand + 1) * (systemVar.rectHeightTotalBand + 1) * 0.5; // threshold: 50%

  for (var i = 0; i <= systemVar.rectWidthTotalBand; i++) {
    var checkX = rectWidthBand[i];
    for (var j = 0; j <= systemVar.rectHeightTotalBand; j++) {
      var checkY = rectHeightBand[j];
      var el = document.elementFromPoint(checkX, checkY);
      if (el === null) {
        notPass++;
        continue;
      }
      var frameId = el.getAttribute('id');
      if (frame_id != frameId) {
        notPass++;
        continue;
      }
    }
  }
  if (notPass > threshold) {
    return false;
  } else {
    return true;
  }
};
var coveredNaCheck = function (vponTag) {
  return function (vponTag) {
    if (window.top == window.self) {
      var vponTagPos = vponTag.getBoundingClientRect();
      var rectWidthBand = divide(vponTagPos.width - 1, systemVar.rectWidthTotalBand);
      var rectHeightBand = divide(vponTagPos.height - 1, systemVar.rectHeightTotalBand);
      var scrollTop = window.pageYOffset !== undefined ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
      var scrollLeft = window.pageXOffset !== undefined ? window.pageXOffset : (document.documentElement || document.body.parentNode || document.body).scrollLeft;
      var notPass = 0; // count how many point wont pass
      var threshold = (systemVar.rectWidthTotalBand + 1) * (systemVar.rectHeightTotalBand + 1) * 0.5; // threshold: 50%

      for (var i = 0; i <= systemVar.rectWidthTotalBand; i++) {
        var checkX = vponTagPos.x + rectWidthBand[i];
        for (var j = 0; j <= systemVar.rectHeightTotalBand; j++) {
          var checkY = vponTagPos.y + rectHeightBand[j];
          var el = document.elementFromPoint(checkX, checkY);
          if (el === null) {
            notPass++;
            continue;
          }
          var className = el.className;
          var parentClassName = el.parentElement ? el.parentElement.className : undefined; // while user click on image tag
          if (className ? className.indexOf('vpon') < 0 : true && parentClassName ? parentClassName.indexOf('vpon') < 0 : true) {
            notPass++;
            continue;
          }
        }
      }
      if (notPass > threshold) return false;else return true;
    } else {
      var rectBottom = currentFrameAbsolutePosition().y + vponTag.getBoundingClientRect().height / 2;
      var rectRight = currentFrameAbsolutePosition().x + vponTag.getBoundingClientRect().width / 2;
      if (window.top.innerHeight - rectBottom >= 0 && window.top.innerWidth - rectRight >= 0) return true;else return false;
    }
  };
}();
var getTransferRectWidth = function getTransferRectWidth(length, vponTag, direction) {
  var reqAdParameters = getReqAdParameters(vponTag);
  var iframeW = reqAdParameters.format.split('x')[0];
  var iframeH = reqAdParameters.format.split('x')[1].split('_')[0];
  var rectWidthBand = divide(iframeW, systemVar.rectWidthTotalBand);
  var result = 0;
  if (direction == '+') {
    result = length + rectWidthBand[systemVar.useWidthBand];
  } else if (direction == '-') {
    result = length - rectWidthBand[systemVar.useWidthBand];
  }
  return result;
};
var getTransferRectHeight = function getTransferRectHeight(length, vponTag, direction) {
  var reqAdParameters = getReqAdParameters(vponTag);
  var iframeW = reqAdParameters.format.split('x')[0];
  var iframeH = reqAdParameters.format.split('x')[1].split('_')[0];
  var rectHeightBand = divide(iframeH, systemVar.rectHeightTotalBand);
  var result = 0;
  if (direction == '+') {
    result = length + rectHeightBand[systemVar.useHeightBand];
  } else if (direction == '-') {
    result = length - rectHeightBand[systemVar.useHeightBand];
  }
  return result;
};
// -------- cover check ----------

// --- precheck vpon tag attribute ---
var checkInput = function checkInput(vponTag) {
  var result = {
    errMsg: '',
    adhesionPosition: false
  };
  var licensekey = vponTag.getAttribute(systemVar.licensekey);
  if (!checkAttributeIsGiven(licensekey)) {
    result.errMsg += 'input licensekey is empty. ';
  }
  var regex = /^[A-Za-z0-9]{32}$/;
  if (!regex.test(licensekey)) {
    result.errMsg += 'input licensekey error length. ';
  }
  result.adType = checkAdType(vponTag);
  var adhesionPosition = vponTag.getAttribute(systemVar.adhesionPosition);
  if (adhesionPosition) {
    if (adhesionPosition === 'top') {
      result.adhesionPosition = 'top';
    } else if (adhesionPosition === 'bottom') {
      result.adhesionPosition = 'bottom';
    } else {
      result.adhesionPosition = 'unknown';
    }
  } else {
    result.adhesionPosition = false;
  }
  return result;
};

/**
 * Check ad type
 * @param {element} vponTag vpon tag element
 * @returns {string|undefined} ad type string
 */
var checkAdType = function checkAdType(vponTag) {
  if (vponTag.getAttribute(websdkParams.format) === null) {
    throw new TypeError("[Vpon-WebSDK] format attribute is null");
  }
  var format = vponTag.getAttribute(websdkParams.format).toLowerCase();
  var adTypeMapping = {
    mi: ["mi"],
    banner: ["320x50_mb", "320x100_mb", "300x250_mb", "320x480_mb", "970x250_mb"],
    na: ["na"]
  };
  var result = Object.keys(adTypeMapping).find(function (key) {
    return adTypeMapping[key].indexOf(format) !== -1;
  });
  if (!result) {
    throw new TypeError("[Vpon-WebSDK] format attribute is unable to mapping");
  }
  return result;
};

// precheck vpon tag attribute 'vpon_ad_licensy_key'
var checkAttributeIsGiven = function checkAttributeIsGiven(attr) {
  if (undefined != attr && attr.trim() != '') {
    return true;
  } else {
    return false;
  }
};

// --- precheck vpon tag attribute ---

// --- <START> check will generate ad or not ---

/**
 * confirm vpon tag exist
 * @returns {boolean} result
 */
var checkVponTagExisted = function checkVponTagExisted() {
  var vponTag = document.querySelectorAll("vpon");
  return Boolean(vponTag.length);
};
var isInCrossDomain = function isInCrossDomain() {
  try {
    window.top.document;
    return false;
  } catch (err) {
    return true;
  }
};
var getReqAdParameters = function getReqAdParameters(vponTag) {
  var reqParameters = {};
  var adType = checkAdType(vponTag);
  if (adType == 'na') reqParameters.cover_min = vponTag.getAttribute(systemVar.nativeCoverMin) || '';
  reqParameters.format = vponTag.getAttribute(systemVar.format);
  reqParameters.sdk = systemVar.sdk;
  reqParameters.bid = vponTag.getAttribute(systemVar.licensekey);
  reqParameters.adtest = vponTag.getAttribute('vpon_ad_test') == 1 ? 1 : 0;
  reqParameters.adRequestCallBack = vponTag.getAttribute(systemVar.adRequestCallBack) || null; // branch:requestAdCallback
  reqParameters.isRotate = vponTag.getAttribute(systemVar.isRotate) || 'true'; // branch:requestAdCallback
  reqParameters.s_h = document.documentElement.clientHeight;
  reqParameters.s_w = document.documentElement.clientWidth;
  return reqParameters;
};
var arrangeReqAdUrl = function arrangeReqAdUrl(baseUrl, reqParameters) {
  // 1. arrange reqParams
  var param_str = '';
  if (reqParameters) {
    for (var key in reqParameters) {
      param_str += key + '=' + encodeURIComponent(reqParameters[key]) + '&';
    }
    param_str = '?' + param_str.substring(0, param_str.length - 1);
  }
  // 2. combine
  var reqAdURLWithQueryString = baseUrl + param_str;
  return "//".concat(reqAdURLWithQueryString);
};
var queryWebApiPermission = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(name) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return navigator.permissions.query({
            name: name
          });
        case 2:
          return _context.abrupt("return", _context.sent);
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function queryWebApiPermission(_x) {
    return _ref.apply(this, arguments);
  };
}();
var isUrl = function isUrl(url) {
  try {
    if (new URL(url)) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
};
var isVpadnEndpoint = function isVpadnEndpoint(url) {
  if (!isUrl(url)) {
    return false;
  }
  var urlObj = new URL(url);
  return urlObj.hostname === apiConfig.hostname;
};
var isWebview = function isWebview() {
  var useragent = navigator.userAgent;
  var regex = '/(WebView|(iPhone|iPod|iPad)(?!.*Safari\/)|Android.*(wv|.0.0.0))/gi';
  return Boolean(useragent.match(regex));
};
var isInGAM = function isInGAM() {
  try {
    if (window.parent.document) {
      var GAMIframeArray = _toConsumableArray(window.parent.document.querySelectorAll('iframe[id^="google_ads_iframe"]'));
      return GAMIframeArray.some(function (iframe) {
        return iframe.contentDocument === document;
      });
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
};

/**
 * Verify CTID format
 * @returns {boolean} Verify result
 */
var verifyCtid = function verifyCtid(ctid) {
  var re = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/;
  var verify = re.exec("".concat(ctid));
  return Boolean(verify);
};

/**
 * check vpon tag attribute format
 * @param {element} vponTag vpon tag element
 * @returns {boolean} result
 */
var checkVponTagAttributes = function checkVponTagAttributes(vponTag) {
  var vponTagAttributes = vponTag.getAttributeNames();
  if (!vponTagAttributes.length) {
    console.error("[Vpon-WebSDK] Vpon tag attribute is empty");
    return false;
  }
  var result = true;
  vponTagAttributes.forEach(function (attribute) {
    switch (attribute) {
      case websdkParams.vponTagAttrs.licensekey:
        if (!websdkParams.regex.licensekey.test(vponTag.getAttribute(attribute))) {
          console.error("[Vpon-WebSDK] Vpon tag lincesekey is invalid");
          result = false;
        }
        break;
      case websdkParams.vponTagAttrs.format:
        if (websdkParams.formatMapping.indexOf(vponTag.getAttribute(attribute)) === -1) {
          console.error("[Vpon-WebSDK] ad format is invalid");
          result = false;
        }
        break;
    }
  });
  return result;
};

/**
 * Check cookie parameters is valid
 * @param {object} checkObj cookie parameter object
 * @returns {boolean} check result
 */
var cookieParamsValidator = function cookieParamsValidator() {
  var checkObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var key = checkObj.key,
    value = checkObj.value,
    options = checkObj.options;
  if (key && typeof key !== "string") {
    console.warn("[Vpon-WebSDK] Key must be a string!");
    return false;
  }
  if (value && typeof value !== "string") {
    console.warn("[Vpon-WebSDK] Value must be a string!");
    return false;
  }
  if (options && (_typeof(options) !== "object" || Array.isArray(options))) {
    console.warn("[Vpon-WebSDK] Options must be an object!");
    return false;
  }
  return true;
};

// --- <END> check will generate ad or not ---

module.exports = {
  coveredBannerCheck: coveredBannerCheck,
  iframeViewable: iframeViewable,
  underViewport: underViewport,
  displayInViewport: displayInViewport,
  getFrameBoundingClientRect: getFrameBoundingClientRect,
  calIframeBoundingClientRect: calIframeBoundingClientRect,
  coveredIntCheck: coveredIntCheck,
  coveredNaCheck: coveredNaCheck,
  getTransferRectWidth: getTransferRectWidth,
  getTransferRectHeight: getTransferRectHeight,
  checkInput: checkInput,
  checkAdType: checkAdType,
  checkAttributeIsGiven: checkAttributeIsGiven,
  checkVponTagExisted: checkVponTagExisted,
  getReqAdParameters: getReqAdParameters,
  arrangeReqAdUrl: arrangeReqAdUrl,
  currentFrameAbsolutePosition: currentFrameAbsolutePosition,
  isInCrossDomain: isInCrossDomain,
  queryWebApiPermission: queryWebApiPermission,
  isUrl: isUrl,
  isVpadnEndpoint: isVpadnEndpoint,
  isWebview: isWebview,
  isInGAM: isInGAM,
  verifyCtid: verifyCtid,
  checkVponTagAttributes: checkVponTagAttributes,
  cookieParamsValidator: cookieParamsValidator
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(4);


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
var _require = __webpack_require__(0),
  TPL_PARAMS = _require.TPL_PARAMS,
  VIDEO_EVENT_URL = _require.VIDEO_EVENT_URL,
  systemVar = _require.systemVar;
var _require2 = __webpack_require__(1),
  isSDKiOS = _require2.isSDKiOS;
var _require3 = __webpack_require__(6),
  isElement = _require3.isElement,
  VponConsole = _require3.VponConsole,
  assets = _require3.assets,
  digitSet = _require3.digitSet,
  isVponOMIDBridgeExist = _require3.isVponOMIDBridgeExist;
var VponVideo = /*#__PURE__*/_createClass(function VponVideo(videoContainer, videoConfig) {
  _classCallCheck(this, VponVideo);
  var video_area = typeof videoContainer === 'string' ? document.querySelector("#".concat(videoContainer)) : videoContainer;
  if (isElement(video_area)) {
    throw new Error('[VponVideo] video container is not dom object');
  }
  var config = null;
  try {
    config = JSON.parse(JSON.stringify(videoConfig));
  } catch (err) {
    throw new Error('[VponVideo] video config is invalid');
  }
  var templateSearchParams = new URL(window.location).searchParams;
  var listeners = [];
  var isAdChoiceActive = false;
  var isPlaying = false;
  var isSendTrackingEventArr = [];
  var videoDurationTemp = 0;
  this.eventListener = {};
  var video = document.createElement('video');
  video.setAttribute('aria-label', systemVar.ariaLabel.video_view);

  /**
   * generate icon mute/unmite area
   * @param {String} domname tag name
   * @param {String} iconMuteSrc icon mute source
   * @param {String} iconUnmiteSrc icon unmute source
   * @returns icon area
   */
  function createIconMuteArea(domname, iconMuteSrc, iconUnmiteSrc) {
    var dom = document.createElement(domname);
    dom.style.width = "32px";
    dom.style.height = "32px";
    dom.style.position = "absolute";
    dom.style[config.mutePosition === 'top' ? 'top' : 'bottom'] = "10px";
    dom.style.right = "15px";
    dom.style.display = config.muteHidden ? 'none' : 'block';
    var img1 = document.createElement("img");
    img1.src = iconMuteSrc;
    img1.id = "icon_mute";
    img1.setAttribute('aria-label', systemVar.ariaLabel.mute_icon);
    img1.style.width = "100%";
    img1.style.height = "100%";
    img1.style.display = "none";
    img1.style.position = "absolute";
    img1.style.top = "0px";
    var img2 = document.createElement("img");
    img2.src = iconUnmiteSrc;
    img2.id = "icon_unmute";
    img2.setAttribute('aria-label', systemVar.ariaLabel.unmute_icon);
    img2.style.width = "100%";
    img2.style.height = "100%";
    img2.style.display = "none";
    img2.style.position = "absolute";
    img2.style.top = "0px";
    dom.appendChild(img1);
    dom.appendChild(img2);
    return dom;
  }
  var iconmuteArea = createIconMuteArea("div", assets.iconMuteSrc, assets.iconUnmiteSrc);
  this.play = function () {
    if (isAdChoiceActive) {
      return;
    }
    var videoPlay = video.play();
    videoPlay.then(function (res) {})["catch"](function (err) {
      if (err.message.indexOf('denied permission') !== -1) {
        var _video_area = typeof videoContainer === 'string' ? document.querySelector("#".concat(videoContainer)) : videoContainer;
        _video_area.appendChild(playBtnAreaNode);
      }
      console.warn(err);
    });
    customTracking(this.eventListener, 'play');
  };
  this.onPlay = function (callback) {
    if (typeof callback === 'function') {
      video.addEventListener('play', function () {
        callback();
      });
    }
  };
  this.pause = function () {
    video.pause();
    customTracking(this.eventListener, 'pause');
  };
  this.onPause = function (callback) {
    if (typeof callback === 'function') {
      video.addEventListener('pause', function () {
        callback();
      });
    }
  };
  this.resume = function () {
    this.playAtPosition(0);
    this.play();
    customTracking(this.eventListener, 'resume');
  };
  this.mute = function () {
    video.muted = true;
  };
  this.unmute = function () {
    video.muted = false;
  };
  this.isMuted = function () {
    return video.muted;
  };
  this.isPaused = function () {
    return video.paused;
  };
  this.isEnded = function () {
    return video.ended;
  };
  this.playAtPosition = function (sec) {
    video.currentTime = sec;
  };
  this.getDuration = function () {
    return video.duration;
  };
  this.getCurrentTime = function () {
    return video.currentTime;
  };
  this.togglePlay = function () {
    var method = video.paused ? 'play' : 'pause';
    this[method]();
  };
  this.toggleMuted = function () {
    var method = video.muted ? 'unmute' : 'mute';
    this[method]();
  };
  this.create = function () {
    bindVideoEvents();
    videoInit(config);
  };
  this.sendLinkTracking = function () {
    sendQuartileTracking(trackingUrl.link);
  };
  this.sendReplayTracking = function () {
    sendQuartileTracking(trackingUrl.replay);
  };
  this.onTimeupdate = function (callback) {
    if (typeof callback != 'function') {
      VponConsole('warn', '[VponVideo] please input callback function');
      return;
    }
    video.addEventListener("timeupdate", function () {
      callback(video.currentTime);
    });
  };
  this.onPlayStatusChanged = function (callback) {
    if (typeof callback != 'function') {
      VponConsole('warn', '[VponVideo] please input callback function');
      return;
    }
    video.addEventListener("play", function () {
      callback(video.paused ? 'pause' : 'play');
    });
    video.addEventListener("pause", function () {
      callback(video.paused ? 'pause' : 'play');
    });
  };
  this.onMuteStatusChanged = function (callback) {
    if (typeof callback != 'function') {
      VponConsole('warn', '[VponVideo] please input callback function');
      return;
    }
    video.addEventListener('volumechange', function () {
      callback(video.muted ? 'muted' : 'unmuted');
    });
  };
  this.onMuteIconClick = function (callback) {
    if (typeof callback != 'function') {
      VponConsole('warn', '[VponVideo] please input callback function');
      return;
    }
    mutedcallback = callback;
  };
  this.onCanBePlay = function (callback) {
    if (typeof callback !== 'function') {
      VponConsole('warn', '[VponVideo] please input callback function');
      return;
    }
    var onCanBePlayCallback = function onCanBePlayCallback() {
      if (isSDKiOS() ? video.readyState >= 1 : video.readyState >= 2) {
        callback();
        video.removeEventListener(isSDKiOS() ? 'loadedmetadata' : 'canplay', onCanBePlayCallback);
      } else {
        VponConsole('warn', "[VponVideo] can not play, readyState is ".concat(video.readyState));
      }
    };
    video.addEventListener(isSDKiOS() ? 'loadedmetadata' : 'canplay', onCanBePlayCallback);
  };
  this.onVideoEnded = function (callback) {
    if (typeof callback != 'function') {
      VponConsole('warn', '[VponVideo] please input callback function');
      return;
    }
    video.addEventListener("ended", callback);
  };
  this.onVideoViewershipListener = function (event, callback) {
    if (typeof callback != 'function') {
      VponConsole('warn', '[VponVideo] please input callback function');
      return;
    }
    switch (event) {
      case 'play':
      case 'pause':
      case 'resume':
      case 'quartileTracking':
        this.eventListener[event] = callback;
        break;
      default:
        VponConsole('warn', '[VponVideo] not support event listener');
    }
  };
  this.changeStyle = function (obj) {
    Object.entries(obj).forEach(function (target) {
      var selectedTarget = null;
      switch (target[0]) {
        case 'mute':
          selectedTarget = iconmuteArea;
          break;
        case 'countdown':
          selectedTarget = videoTimeSpan;
          break;
        case 'replay':
          selectedTarget = replayButton;
          break;
      }
      if (selectedTarget) {
        Object.entries(target[1]).forEach(function (item) {
          switch (item[0]) {
            case 'position':
              switch (item[1]) {
                case 'leftTop':
                  selectedTarget.style.top = '10px';
                  selectedTarget.style.bottom = 'auto';
                  selectedTarget.style.left = '15px';
                  selectedTarget.style.right = 'auto';
                  break;
                case 'rightTop':
                  selectedTarget.style.top = '10px';
                  selectedTarget.style.bottom = 'auto';
                  selectedTarget.style.left = 'auto';
                  selectedTarget.style.right = '15px';
                  break;
                case 'leftBottom':
                  selectedTarget.style.top = 'auto';
                  selectedTarget.style.bottom = '10px';
                  selectedTarget.style.left = '15px';
                  selectedTarget.style.right = 'auto';
                  break;
                case 'rightBottom':
                  selectedTarget.style.top = 'auto';
                  selectedTarget.style.bottom = '10px';
                  selectedTarget.style.left = 'auto';
                  selectedTarget.style.right = '15px';
                  break;
              }
              break;
            case 'display':
              selectedTarget.style.display = item[1];
              break;
          }
        });
      }
    });
  };
  this.destroy = function () {
    videoDestroy();
  };
  function videoDestroy() {
    var video = video_area.querySelector('video');
    video.src = '';
    video.removeEventListener('timeupdate', handleTimeUpdateFunc);
    video.remove();
  }
  this.triggerVideoStartCallback = function (listener) {
    if (typeof listener !== 'function') {
      VponConsole('warn', '[VponVideo] args is not a function');
      return;
    }
    listeners.push(listener);
  };
  var eventsLister = this.eventListener;
  function bindVideoEvents() {
    video.addEventListener('abort', handleVideoAbort);
    video.addEventListener('canplay', handleVideoCanBePlay);
    video.addEventListener('canplaythrough', handleVideoCanPlayThrogh);
    video.addEventListener('durationchange', handleVideoDurationChange);
    video.addEventListener('emptied', handleVideoEmptied);
    video.addEventListener('ended', handleVideoEnded);
    video.addEventListener('error', handleVideoError);
    video.addEventListener('loadeddata', handleVideoLoadeddata);
    video.addEventListener('loadedmetadata', handleVideoLoadedmetadata);
    video.addEventListener('loadstart', handleVideoLoadstart);
    video.addEventListener('pause', handleVideoPause);
    video.addEventListener('play', handleVideoPlay);
    video.addEventListener('playing', handleVideoPlaying);
    video.addEventListener('progress', handleVideoProgress);
    video.addEventListener('ratechange', handleVideoRatechange);
    video.addEventListener('seeked', handleVideoSeeked);
    video.addEventListener('seeking', handleVideoSeeking);
    video.addEventListener('stalled', handleVideoStalled);
    video.addEventListener('suspend', handleVideoSuspend);
    video.addEventListener('timeupdate', handleVideoTimeupdate);
    video.addEventListener('volumechange', handleVideoVolumechange);
    video.addEventListener('waiting', handleVideoWaiting);
  }
  function handleVideoAbort() {
    VponConsole('warn', '[VponVideo] video was aborted');
    return false;
  }
  function handleVideoCanBePlay() {}
  function handleVideoCanPlayThrogh() {}
  function handleVideoDurationChange() {}
  function handleVideoEmptied() {}
  function handleVideoEnded() {
    util.track();
    if (config.loop === true) {
      video.play();
    }
  }
  function handleVideoError() {
    VponConsole('warn', '[VponVideo] video was error');
    return false;
  }
  function handleVideoLoadeddata() {}
  function handleVideoLoadedmetadata() {}
  function handleVideoLoadstart() {}
  function handleVideoPause() {
    if (!video.ended) {
      if (window.vponOMIDBridge !== undefined && window.vponOMIDBridge.videoEvents !== undefined) {
        VponConsole('log', '[VponVideo] fire vponOMIDBridge.videoEvents.pause()');
        window.vponOMIDBridge.videoEvents.pause();
        if (vponOMIDBridge.isSupportOMEventOccur !== undefined && vponOMIDBridge.isSupportOMEventOccur) {
          VponConsole('log', '[VponVideo] fire omEventOccur.');
          fireOMEventOccur(vponOMIDBridge.deviceType, 'pause', vponOMIDBridge.sessionId);
        }
      }
    }
    if (isSendTrackingEventArr.indexOf('videoPause') === -1) {
      isSendTrackingEventArr.push('videoPause');
      sendQuartileTracking(trackingUrl.pause);
    }
  }
  function handleVideoPlay() {
    if (playBtnAreaNode) {
      playBtnAreaNode.remove();
    }
    if (video.currentTime !== 0) {
      if (window.vponOMIDBridge !== undefined && window.vponOMIDBridge.videoEvents !== undefined) {
        VponConsole('log', '[VponVideo] fire vponOMIDBridge.videoEvents.resume()');
        window.vponOMIDBridge.videoEvents.resume();
        if (vponOMIDBridge.isSupportOMEventOccur !== undefined && vponOMIDBridge.isSupportOMEventOccur) {
          VponConsole('warn', '[VponVideo] fire omEventOccur.');
          fireOMEventOccur(vponOMIDBridge.deviceType, 'resume', vponOMIDBridge.sessionId);
        }
      }
    }
    if (isSendTrackingEventArr.indexOf('videoPlay') === -1) {
      isSendTrackingEventArr.push('videoPlay');
      sendQuartileTracking(trackingUrl.play);
    }
  }
  function handleVideoPlaying() {
    if (video.poster && isSDKiOS()) {
      video.removeAttribute('poster');
    }
  }
  function handleVideoProgress() {}
  function handleVideoRatechange() {}
  function handleVideoSeeked() {}
  function handleVideoSeeking() {}
  function handleVideoStalled() {}
  function handleVideoSuspend() {}
  function handleVideoTimeupdate() {}
  function handleVideoVolumechange() {}
  function handleVideoWaiting() {}

  // Draw play button area
  function generatePlayBtnArea(poster) {
    var playBtnArea = document.createElement('div');
    playBtnArea.id = 'playBtnDiv';
    playBtnArea.style.width = '100%';
    playBtnArea.style.height = '100%';
    playBtnArea.style.position = 'absolute';
    playBtnArea.style.top = "0px";
    playBtnArea.style.zIndex = '9999';
    // It's current white poster, need to change to black ??
    playBtnArea.style.backgroundImage = poster ? poster : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAApsAAAF3AQMAAADQMhJDAAAABlBMVEUAAAAAAAClZ7nPAAAACXBIWXMAAA7EAAAOxAGVKw4bAAADh0lEQVR4nO2YsW7bMBCGqQqwloBaMwhyH8GjBqN+FT2CxgxBrUfTA/QhWHToVmj0EITlHU+kLBm1GGcq/g+JIonmh6N4OtJRCgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwB0qOmTDjZabNzdR2Is7nm3vfq290lirVOluXtyH7HuKdE8fz6w1K2lBlx+Tfle1628yQxdXA973+cgnjSpSjI6L+uIG2auvLO1nLUdqJA5Kpzl9hLVc5XPpgb2OLlWaDxKUv1q0cmaoNlVacGwv09Wi1ctMspSP3ZVkIXWzlyidYvE8LVp3LO1TpdfvU7Vo5XHkD0qfb0rXj+UOrAnp2dySFslS1oT0PNyS7pKlrAnp2S1aeaL0egKTpO100vs/HOFTspRjCzlv6DDEmWNp9aB0EHMuUpY9J0tbOuzkwgfYTS+vJFyTLs3eSbo3LO1FUkor58Zh/VLcwexdedeZfaMLn1pVLIWdHFKl52JUuhjPLOVbOpRCX2xbJ/VnW/k5urqn9/4p+gkrQin0j9b5qpNNkf4a1DeljyqnUPyEuYfg1ya3fhGDky7W2Tv8plnR7rGRx7+N2SCDtaO/dGugycYE6R8arjZ+TiRzjKSpSHsnjYvDFn7QcJ8Gnz0yyZ2kacYPklKijsvYFi70+rgVmjuJtJnStBhUKGH1qus/pRlLSSjltAoCGr+8wynVb6RsLCUSkeow1CZKUzYpFAtLKRKp0UWYFAp/ly419KtFKjU6D+kzNaj1PmOztPX34jtJNyXPrnZEG6Qt9d2psPznQUpjrj4m7bT0F1kRhv8Z0sHfK8NKTabnx6TTylSH8kmm5nOkx5DoD0iniZr6vYScpDtdPH1EOgbBB6XUxVBkOuR3ZsKGjUztY1IZtaumZiY1nyJ11XTaU1HsJp5uhebWUBQ6lI4ybilnyZtSUBrKJJJWoXTUcZ2f5VmK9MjSYS49xopcLvZqG6loCqhjE+J7iWHpOEEpUj8/Zr65GaOpjqcpO5+Sf0b+8f2omoYXNkpTVlOXPzWNmFQy5yQkUxufxCFt3XcF+VW5nQ+txovvJq+KtiWFDzNph6LeaEUqh5NaSU99OYh0P9Dpds7W0D8h6B8Pi+8mhbW9zHphk3Z9quSP87Zp+YWHd8I6ngIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwH/FX4Ok7MIGd0maAAAAAElFTkSuQmCC';
    playBtnArea.style.backgroundSize = 'cover';
    var playBtn = document.createElement('img');
    playBtnArea.id = 'playBtn';
    playBtn.src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB4CAYAAAFOYwZEAAAKQ2lDQ1BJQ0MgcHJvZmlsZQAAeNqdU3dYk/cWPt/3ZQ9WQtjwsZdsgQAiI6wIyBBZohCSAGGEEBJAxYWIClYUFRGcSFXEgtUKSJ2I4qAouGdBiohai1VcOO4f3Ke1fXrv7e371/u855zn/M55zw+AERImkeaiagA5UoU8Otgfj09IxMm9gAIVSOAEIBDmy8JnBcUAAPADeXh+dLA//AGvbwACAHDVLiQSx+H/g7pQJlcAIJEA4CIS5wsBkFIAyC5UyBQAyBgAsFOzZAoAlAAAbHl8QiIAqg0A7PRJPgUA2KmT3BcA2KIcqQgAjQEAmShHJAJAuwBgVYFSLALAwgCgrEAiLgTArgGAWbYyRwKAvQUAdo5YkA9AYACAmUIszAAgOAIAQx4TzQMgTAOgMNK/4KlfcIW4SAEAwMuVzZdL0jMUuJXQGnfy8ODiIeLCbLFCYRcpEGYJ5CKcl5sjE0jnA0zODAAAGvnRwf44P5Dn5uTh5mbnbO/0xaL+a/BvIj4h8d/+vIwCBAAQTs/v2l/l5dYDcMcBsHW/a6lbANpWAGjf+V0z2wmgWgrQevmLeTj8QB6eoVDIPB0cCgsL7SViob0w44s+/zPhb+CLfvb8QB7+23rwAHGaQJmtwKOD/XFhbnauUo7nywRCMW735yP+x4V//Y4p0eI0sVwsFYrxWIm4UCJNx3m5UpFEIcmV4hLpfzLxH5b9CZN3DQCshk/ATrYHtctswH7uAQKLDljSdgBAfvMtjBoLkQAQZzQyefcAAJO/+Y9AKwEAzZek4wAAvOgYXKiUF0zGCAAARKCBKrBBBwzBFKzADpzBHbzAFwJhBkRADCTAPBBCBuSAHAqhGJZBGVTAOtgEtbADGqARmuEQtMExOA3n4BJcgetwFwZgGJ7CGLyGCQRByAgTYSE6iBFijtgizggXmY4EImFINJKApCDpiBRRIsXIcqQCqUJqkV1II/ItchQ5jVxA+pDbyCAyivyKvEcxlIGyUQPUAnVAuagfGorGoHPRdDQPXYCWomvRGrQePYC2oqfRS+h1dAB9io5jgNExDmaM2WFcjIdFYIlYGibHFmPlWDVWjzVjHVg3dhUbwJ5h7wgkAouAE+wIXoQQwmyCkJBHWExYQ6gl7CO0EroIVwmDhDHCJyKTqE+0JXoS+cR4YjqxkFhGrCbuIR4hniVeJw4TX5NIJA7JkuROCiElkDJJC0lrSNtILaRTpD7SEGmcTCbrkG3J3uQIsoCsIJeRt5APkE+S+8nD5LcUOsWI4kwJoiRSpJQSSjVlP+UEpZ8yQpmgqlHNqZ7UCKqIOp9aSW2gdlAvU4epEzR1miXNmxZDy6Qto9XQmmlnafdoL+l0ugndgx5Fl9CX0mvoB+nn6YP0dwwNhg2Dx0hiKBlrGXsZpxi3GS+ZTKYF05eZyFQw1zIbmWeYD5hvVVgq9ip8FZHKEpU6lVaVfpXnqlRVc1U/1XmqC1SrVQ+rXlZ9pkZVs1DjqQnUFqvVqR1Vu6k2rs5Sd1KPUM9RX6O+X/2C+mMNsoaFRqCGSKNUY7fGGY0hFsYyZfFYQtZyVgPrLGuYTWJbsvnsTHYF+xt2L3tMU0NzqmasZpFmneZxzQEOxrHg8DnZnErOIc4NznstAy0/LbHWaq1mrX6tN9p62r7aYu1y7Rbt69rvdXCdQJ0snfU6bTr3dQm6NrpRuoW623XP6j7TY+t56Qn1yvUO6d3RR/Vt9KP1F+rv1u/RHzcwNAg2kBlsMThj8MyQY+hrmGm40fCE4agRy2i6kcRoo9FJoye4Ju6HZ+M1eBc+ZqxvHGKsNN5l3Gs8YWJpMtukxKTF5L4pzZRrmma60bTTdMzMyCzcrNisyeyOOdWca55hvtm82/yNhaVFnMVKizaLx5balnzLBZZNlvesmFY+VnlW9VbXrEnWXOss623WV2xQG1ebDJs6m8u2qK2brcR2m23fFOIUjynSKfVTbtox7PzsCuya7AbtOfZh9iX2bfbPHcwcEh3WO3Q7fHJ0dcx2bHC866ThNMOpxKnD6VdnG2ehc53zNRemS5DLEpd2lxdTbaeKp26fesuV5RruutK10/Wjm7ub3K3ZbdTdzD3Ffav7TS6bG8ldwz3vQfTw91jicczjnaebp8LzkOcvXnZeWV77vR5Ps5wmntYwbcjbxFvgvct7YDo+PWX6zukDPsY+Ap96n4e+pr4i3z2+I37Wfpl+B/ye+zv6y/2P+L/hefIW8U4FYAHBAeUBvYEagbMDawMfBJkEpQc1BY0FuwYvDD4VQgwJDVkfcpNvwBfyG/ljM9xnLJrRFcoInRVaG/owzCZMHtYRjobPCN8Qfm+m+UzpzLYIiOBHbIi4H2kZmRf5fRQpKjKqLupRtFN0cXT3LNas5Fn7Z72O8Y+pjLk722q2cnZnrGpsUmxj7Ju4gLiquIF4h/hF8ZcSdBMkCe2J5MTYxD2J43MC52yaM5zkmlSWdGOu5dyiuRfm6c7Lnnc8WTVZkHw4hZgSl7I/5YMgQlAvGE/lp25NHRPyhJuFT0W+oo2iUbG3uEo8kuadVpX2ON07fUP6aIZPRnXGMwlPUit5kRmSuSPzTVZE1t6sz9lx2S05lJyUnKNSDWmWtCvXMLcot09mKyuTDeR55m3KG5OHyvfkI/lz89sVbIVM0aO0Uq5QDhZML6greFsYW3i4SL1IWtQz32b+6vkjC4IWfL2QsFC4sLPYuHhZ8eAiv0W7FiOLUxd3LjFdUrpkeGnw0n3LaMuylv1Q4lhSVfJqedzyjlKD0qWlQyuCVzSVqZTJy26u9Fq5YxVhlWRV72qX1VtWfyoXlV+scKyorviwRrjm4ldOX9V89Xlt2treSrfK7etI66Trbqz3Wb+vSr1qQdXQhvANrRvxjeUbX21K3nShemr1js20zcrNAzVhNe1bzLas2/KhNqP2ep1/XctW/a2rt77ZJtrWv913e/MOgx0VO97vlOy8tSt4V2u9RX31btLugt2PGmIbur/mft24R3dPxZ6Pe6V7B/ZF7+tqdG9s3K+/v7IJbVI2jR5IOnDlm4Bv2pvtmne1cFoqDsJB5cEn36Z8e+NQ6KHOw9zDzd+Zf7f1COtIeSvSOr91rC2jbaA9ob3v6IyjnR1eHUe+t/9+7zHjY3XHNY9XnqCdKD3x+eSCk+OnZKeenU4/PdSZ3Hn3TPyZa11RXb1nQ8+ePxd07ky3X/fJ897nj13wvHD0Ivdi2yW3S609rj1HfnD94UivW2/rZffL7Vc8rnT0Tes70e/Tf/pqwNVz1/jXLl2feb3vxuwbt24m3Ry4Jbr1+Hb27Rd3Cu5M3F16j3iv/L7a/eoH+g/qf7T+sWXAbeD4YMBgz8NZD+8OCYee/pT/04fh0kfMR9UjRiONj50fHxsNGr3yZM6T4aeypxPPyn5W/3nrc6vn3/3i+0vPWPzY8Av5i8+/rnmp83Lvq6mvOscjxx+8znk98ab8rc7bfe+477rfx70fmSj8QP5Q89H6Y8en0E/3Pud8/vwv94Tz+4A5JREAAAAZdEVYdFNvZnR3YXJlAEFkb2JlIEltYWdlUmVhZHlxyWU8AAADJWlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxNDggNzkuMTY0MDM2LCAyMDE5LzA4LzEzLTAxOjA2OjU3ICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdFJlZj0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlUmVmIyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgMjEuMCAoTWFjaW50b3NoKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpFREFCMDE5REM3OTQxMUVDOUY5QzlGNkZEOTcxN0E1QiIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpFREFCMDE5RUM3OTQxMUVDOUY5QzlGNkZEOTcxN0E1QiI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkVEQUIwMTlCQzc5NDExRUM5RjlDOUY2RkQ5NzE3QTVCIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkVEQUIwMTlDQzc5NDExRUM5RjlDOUY2RkQ5NzE3QTVCIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+JmED4AAAELhJREFUeNpiZsAPHICYG4hfY5NkxCI2E49hr4C4FpfmmQzEgXR0zcRqhBvAhEujubk5PwHN7Iw4NLPevXvXF8RQVlZeh0s3EyG3AQ0JAmFcmu2J8SDIgDt37gSia35FbAipqqgeROazAPF1IjSd/ff/30OS/Pzhw4ffoADDphE5npuAWBw9xIH4NzHxXIdF8jch71AtecIAGxBPxqcJBgACCB8AZUV3UpxNyOnpuDQT699iIP6CHM/dJGTFXvREwoeejgkYMBOmeSapuYmkLBkcHCyBzXZGbDbjshG9YGAiNpSeP3/+E12MhRiNQBs3Y0nr/0GaT4LKO2yaVJRVDv5n+P8Wh5kZWAtAJgZG6X8M/58Syhzkltvp6AGWRYpGdM1/CWS5z+jyAAHESKRtIHUziFQLioB5pJZCyKAbPb+QCdKpUY5QArKB+A+l5S7FIcBIQhwyAfN4ALziU1Vd/+/fv//kWs5Igk/hrQx08PXr1196enpbSLD4AAu0QqEIcHNzsyGXePiaP7A2JchiW2pHIswRQAdsAFL/sKkBWbwDiAOpZamqssoJYLn3HFSq4lPHQqlFdbV1D5YtW3oTaMtXErTlsCAlcUIJ7D+ar17gCkYCANQc+E3vfLwclKJxlVw8yG0NahccxFYSlIbAUiA+RGolgQ2EArELDjlQfOcD8S9iDAIIIEYyfaINxDJADGrVnIG1H0kBxFqchKuRg61hQygPE2NxMxCLUbMeJsZiamQtUJOnhFiLQZVGHy2zEjaLQSXZVFo2AHC1y2llKUZniYmOxSUfNovZCemKi4uTvnnzpj+Fls9Ej2OCvkVuYbx79+6bqanpDjItB+dzJnJ0CgkJcYEcUlJSokSG9hmwoA4jN9wyMzMNQA5gY2Mj2QMgDc6Upprr168HENErJ62DTWojb+vWrXZEKOVlonae0dDQEAE5gIWFBV9xbMxEq0x74MABDzzSHCy0sBTYGDxDoGv/mKo+Listu6eirLwDaOkjaGcdF7jKAm2yUOSAV69e/bKytDr2n+H/O2L1gCzOA+IpFPYcSG5jszAQMXiJDairqp378+/vUzL0n0bOxx+J1dXa0voIGI+7gJY+INPRc9AbAjPxt5EYhSD9GOLjEVtyYIDOUjAjCYJ8rYdH03copgQUYSsyD9Nj7ANXWZ1OI0tLiG3eUrMZlIWtMGHGoXgLEXFObPD+J7cLQ84IXx60X0WVThtoimUSnuJ1PxCvINYwgABipFFiAk2sgFokDmTY8R86arCeUKiRA6jhYVCTvBXUmqFxMQDq/1VTGgjkehjUnItmGFiwDIgP0tLDoJJmGsPgBCgj8JR6GJRUexiGBiiBJn2yPTyTYWiCdHzJFBuwhRYQQxWAZk1A44wPiIlhbMsNhipAWXSDzcNUmUdEHxX48+fPXxsbm22vX7/+PQCeBsV0MTYPkzIijLcbBvSwHz4Fly9ffhkQEHCUjp4+BcRzkT3MSkkHFb0piGvmERcICwvbc/bs2U809nQOA9Jk03QG6o03kexhZHDs2LEnsbGxp2jgYVCTNYMFR4dtwICVlZUMMMBkoHn/n6mp6ZZPnz79oYLRjDCPag7WIpaFhYXp/PnzfrD1Rjk5OQoUGqkN8jVosC+Qiu6kKEkTC4hYAIANrGeiwggKXcGG9etfqyqrHCKz4/MDlIdBs59Rg9WD//79Y7Cxtrn0+tWrT/8Z/n/8T1n38CzIw18Hmyd37NjxLjc75w7QcyBPgtz3l1p9algpvZeBCnMvZNcX//8zONg7XHr29OlnaCz+oIE1B8AFIZSzit4e3r9v3/u01LTbQM+BPPmFirGICyxH9jCsS0XT7qCbq+uV+/fuf0TKi//pFL4Z8KoOTSKXAfeqZqJT6NWrVz9pa2vzQfPiXWhepEcsYgN5yAFLq5FpRmij5i/DwAKMgQAmPAopacz/H2DPfmIgYakrSuuOgbZrQGgB8A7oEdtaocUyH2qDImLaFOQ0z6i1uppaSbeU5C4TBYCSZWzkAoxxKnp6GB0kArEFlc0ELfifT606m5GOMQMqB+SBWBiIuaBi34AYtEXkIb3a9AAB2DvfkCbCOI4/21xEGUklMtBo0GakK9qYgpabpJWhwmy+VSEhCISC3kgEQRH6yvWmd0LUG7E3vizYm8JqaRRzQrWtXLoZUoRaWCjben7rzvTcndv9ee457Qe/N+52dx/v7vl33+9vJIEP4jThLEL/XGbzOEHmPU3qJJQCrmQWFUpFfHcWpr04g7QDW9BfGbNRxn3CXQAvw8M0AYMZsI3A3QgvyB+rCXyMGdWQDlBtviUJDN/x4dyp4oADFgiuiOmqDHlub8V5B8ngj5EYcPxmnBGmW1PkCnfirKFwDP0S5325ga8z/SitMYPztly39E2R/SnJgMoGDpSDyGUz4Ks4zRqZB+9hxgIBscDgk3IhbcUBpgX/xLeBXuC/1Y60Ge1C83US8lK14lKuV/gy2hrRkwswPNPHtwhwZbYBEhe4T44jhcPhjL9ncHDQrjJ0nxCwEcmwOOfxeEwGgyGzX7fbfQjABwYGbCp2VUY+YFmUd3a7fYOorbW11QLg3d3dZSpA3+ADNskyqi8o4O3be3t7nQDucDhILvOWZAOuIrmKMjw83DAxMdEsxkQoMqq5wB2k7zOoUgHmxZGRkVoCh+vgAhtValSQzWYrkeBZzWf+vAqs5srFaoBXNhqNtpnNZqXOZxcLXIcoCZ1Oh/x+//lAIHBWgd3XscBViLIoLi7eDbd5f39/hYy7dbLAZYjS8Hq95QDudDrl6MZKhaaHVMXQ0FBDMBhs1uv1ktfRNQEMUVhYuCMSiXh8Pp9tWwCz0dLSYnG5XPu3DTDE6/Hx5W0BnEwm044T9jdLS0srWx4YyhscsZYHFhYX5qRoMQtoB5VbWQvAMzT2xVCfs+7kqUlGfApqHam+hzgLPEYTMAjC6931ICWWQxC+NlZLTDyjBRYq7pVbrIFEIv4lhdLf0vI6xJ+yV/i32qCEtNO/1jZaK2rMiaHOS21NbSidTv9knlOlvIkr3Fb6Ac6LpEBB8t/Y0Bj6HIstEhKLP+T2w2OkYKHMjPWwJRCLTc3i5/Qr06cqrYx/la0fBoGYSakjPh8dXejq7PpA0OPAxhzfwANKU0h2mCbiiXWNIBSFr3ZWhZKp1A+Fn1O+uLVuVYXzoWRpsA7p9kY/Rk+DUbLpXNO72NTUvAqmDjY21H7kAksuXaHL/HCCDqZvKQyKr2qmO0ghdWKDOp47eYDnSpLGEa4kbozmIJmSvWrBhrINR/+/EGfimsZheW0BfC++lpmhWIUGYR8hgd8hEVoAAAPme43Bwvn6hTbYTKcFmic7osfFIhQgLN9UwZCLEg+mVSAVLqIYdpo7wJACDAE1AqHyIY16yxcoD4Noviv5FspacKgxn5c9QOyri7tIowJxKe9qQAfVowLsPSmjQTlMHmdwXiAACnU7nkjdiRZsPPD4ROTaoVJGraPMVRcjLIf1Y7DsTCpxYiSteKXMisq+NX/7zqy0xEmdxB8B2ju7mLbKMI6/TlazCtOageCCDiWZ0TC4mLosS1CcySABWWpiYoYJ7AI1ukQvuDAkAhHCmIAZH14QS8yIAZMqd164ABcEuSFhSCuzMGP4WHWGbqkc2kNHPf/2PebY9dCWfr2n5/0nJxlbE87pb897nvfj+T+pfOBE65B0PUu/yKP0OhLn2wOj/9/StU4vgLhFNGbfoyXAgIXTzCdJ0AXrIAP3tEMnY3PSNU8Y2MfQCmDAQ235G0SbJpNYDP6Jzi93OODggjhqhCpJ8n2a0yGsD6P2d4rEv7GtGcAmEnRmO0H0JywZo9uYK9MAIzrf1SlUNWGK8A2Jz9sp7YDP0rnSAc5TVbt0Toh3t18LgJH1vi9dz3N2MQu7B9jME1gEjFJ0rB4+xTnFLSyE9JIY2jIlEzAWG2C7Xsi5JFw4+or9he10AWbVviTTFJdP3H4AY5X9E548pTwZw7D9WzIB47Mf8OlO2qdX/bFEc7SAsUDRQhipttW5sPbdSoI7UxEVzakOROynRANFPjpRFl1jwE6XM17AcMavZ+XJUB9fXV2dV1xcbESBxPb29q6OQaPiG2ewb+13iE6VIWdEZWdnZ83MzJyD9UXov/klTU9Pr7a3t9sdDoegQ9Cwsf0xVsBogneBkQd4qKmp6XhjY+ML0XxYEARxdHT0Znd394rH49FLhI8QlQbKB1SmQRcYuvmHTSbTo9F+2Gg0GhoaGkpsNlvAwWtqaur1mpqavAwHDF7HowGMLPkSgw+w7wWZwsLCx3p7e88AtjSE18ISIjc392AGQv4o3CwnFDAaOxoyBe4DDysJFhizs7PVAC69u8+azeb8DAGM/7QX9wKMk7+lREcqKCg43NXVdVqO7v7+/lKNRzemtCVqgGv1PLlEdFdWVj4nRzfe3dLPRzT4KOdDJ80QTizyHaGQd7cU0QE7NVEUfWNjYzc7OzsdGsjMcXwYpYM2ZQSf4kjVZTAYsurq6l6UM3Or1Xq6pKQkm+FbPhUawaUcY/QqKyvLHx8fDyRnLpdLGBgYWBweHl5j6BZPKN/BqBo8xLHtT9Ic3djc3PyynKj19fWxkKhhuvSMDPhJjilxiVpVVdV/idr169dfq6ioeCJNt5MvAzZxNMlRUVGRaWho6FXAtlgsJ1M9uMiA+cmMFKi8vPxps9mcyj4+j8hJ1i7/+pOrjY0N78X6Brtj2XGXBlQqvnOvDNjFESRe8/Pz7tbPWlYXFxfhsOTxE79A7d9SFVAuGbCT44hfgiDcH7ZYnIODg3+KXhHVhV4Jqocao91Pw0jplAHj/O02nyrFroWFhX86Pm9fm5ubQyXhTjBCA1B9FKo/TbeGkeIP5ULHDcJXsyJ/ax7P7si1a86+q31OatktRyncxXwM5TML8h9kwLMccHjZ7fattpbWVQajdC/NhgL+lTDqEp7mKPXRBInFKFUTvEVsoYAhlDFe0iPUpaUloaO9Y+3nmZl7iiiVht+AFQOrUaqmH5Q/KAHb6Ls44zceRFHc/W5s7K+e7p7bbrd7h0apl2a8WojSvd69v6gBhiwk6KVsyDSoy8vLQltrG6IUVfViEGZg6NVilIYTnuPr0L/MCpNeXyXaN9lVRqlTilIxZF6q5ShV0wAJY+kUrhwFPno4Z8vM0dmtra2oXGpWVlaEy52X1ycnJu5laJSqaYSoGCmr1RvhEDXaHbJQ2eCfnJjcrK+vf6Cfpc/n839vtd65cuWL23ddLq8cpRTuDtHHOvs4UTn0DkU6klohXW+n+QHQ0M+Yk53z+Ju1tXnSNEYCPuHe3Nz00ozXSzNeMcOjNJxggb6nK3g0Z45xDPNDBiAb6IiDe/YpFhr0uhsWldEwrw/W4FoMZRHVLiCv8NfePHeQJKHCXykUp31Mom8JwBW/UuLREao66TrDv/ukK+UuO0phDxkGaMc4h4QL3VV6SBp9spQ6TEEf5VziFnoEfUkYcboLFbLs90iw1okrNsGr8iuSYAf5ZLrNwsDlLcKP5UZKnqyRFitYBSwrhyZkvP7p/9MddDN2J/sXpdrxHS3j3tEpbED9lmSg47ua5J4N54g2GiTGKkQn7I3QD1E3PRsiAX+FBF3ctOg7DZ9ntDHlXVdizMqx2fESzcxZOGkCeHYS7Jt0g/C+SUmFf4wE65uVnc/iOcAPWHfoXHSdLjb8zjpELh3rXz+Gkb/9kEOjAAAAAElFTkSuQmCC';
    playBtn.style.position = 'absolute';
    playBtn.style.top = '50%';
    playBtn.style.left = '50%';
    playBtn.style.transform = 'translate(-50%, -50%)';
    playBtn.style.zIndex = '9999';
    playBtnArea.appendChild(playBtn);
    playBtnArea.addEventListener('click', function (e) {
      e.stopPropagation();
      playBtnArea.remove();
      video.play();
    });
    this.clickPlayButton = function (callback) {
      playBtnArea.addEventListener('click', function (e) {
        if (typeof callback === 'function') {
          callback();
        }
      });
    };
    return playBtnArea;
  }

  //--
  var trackingTimes = {};
  var trackingTimesArray = [];
  var OnceArray = [];
  var mutedcallback = "";
  var playBtnAreaNode = generatePlayBtnArea.call(this, config.poster);
  function switchmuteicon(iconmuteArea, h) {
    if (h.muted == true) {
      iconmuteArea.children[0].style.display = "none";
      iconmuteArea.children[1].style.display = "block";
      h.muted = false;
    } else {
      iconmuteArea.children[0].style.display = "block";
      iconmuteArea.children[1].style.display = "none";
      h.muted = true;
    }
  }
  function videoInit(config) {
    if (!config.src) {
      VponConsole('error', '[VponVideo] please input video src');
      return false;
    }
    video.preload = 'metadata';
    video.poster = config.poster ? config.poster : assets.videoPosterSrc;
    video.src = config.src;
    video.loop = false;
    video.muted = true;
    video.autoplay = false;
    video.style.width = '100%';
    video.style.height = '100%';

    //detect ad container hide
    window.addEventListener('message', function (e) {
      if (e.data.event === 'destroy') {
        videoDestroy();
      }
      if (e.data.event === 'adChoiceActive') {
        isAdChoiceActive = true;
        video.pause();
      }
      if (e.data.event === 'adChoiceInactive') {
        isAdChoiceActive = false;
        video.play();
      }
    });
    video.setAttribute("webkit-playsinline", "webkit-playsinline");
    video.setAttribute("playsinline", "playsinline");
    video.setAttribute("x5-playsinlin", "");
    video.setAttribute("x-webkit-airplay", "allow");
    var video_area = typeof videoContainer === 'string' ? document.querySelector("#".concat(videoContainer)) : videoContainer;
    video_area.classList.add('omid-element');
    video_area.appendChild(video);
    if (config.showmuted !== false) {
      video_area.appendChild(iconmuteArea);
      iconmuteArea.addEventListener("click", handleIconMuteAreaClick);
      iconmuteArea.children[0].style.display = "block";
    }
  }
  function handleIconMuteAreaClick(e) {
    e.stopPropagation();
    e.preventDefault();
    switchmuteicon(iconmuteArea, video);
    if (OnceArray.indexOf("trackingTimesArray") == -1) {
      sendQuartileTracking(trackingUrl.changemute);
      OnceArray.push("trackingTimesArray");
    }
    if (mutedcallback) {
      mutedcallback();
    }
  }
  function handleTimeUpdateFunc() {
    if (video.poster && isSDKiOS()) {
      video.removeAttribute('poster');
    }
    if (playBtnAreaNode) {
      playBtnAreaNode.remove();
    }
    util.track();
    handleTimeUpdate();
  }
  "";
  function customTracking(eventListener, event, ret) {
    if (eventListener.hasOwnProperty(event)) {
      var listener = eventListener[event];
      listener(ret);
    }
  }
  var track = function track() {
    var videoLeftTime = 0;
    if (!video.duration) {
      videoLeftTime = Math.floor(videoDurationTemp - video.currentTime);
    } else {
      videoLeftTime = Math.floor(video.duration - video.currentTime);
      videoDurationTemp = video.duration;
    }
    sendVideoTrackings(eventsLister, videoLeftTime);
  };
  function sendVideoTrackings(eventsLister, videoLeftTime) {
    if (trackingTimesArray.length > 0) {
      trackingTimesArray.filter(function (trackingTimesElement) {
        return videoLeftTime <= trackingTimesElement.time;
      }).map(function (missDeliverElement) {
        sendVideoTracking(eventsLister, missDeliverElement.time);
      });
      trackingTimesArray = trackingTimesArray.filter(function (trackingTimesElement) {
        return videoLeftTime > trackingTimesElement.time;
      });
    }
  }

  /**
   * Send tracking by trackingUrls.
   * @param {Array} trackingUrls
   */
  function sendQuartileTracking(trackingUrls) {
    if (typeof window.navigator.sendBeacon != "undefined") {
      for (var i in trackingUrls) {
        if (trackingUrls[i]) {
          navigator.sendBeacon(trackingUrls[i] + '&r=' + video.currentTime);
        }
      }
    } else {
      for (var _i in trackingUrls) {
        if (trackingUrls[_i]) {
          var trackingSender = createTrackingSender();
          trackingSender.src = trackingUrls[_i] + '&r=' + video.currentTime;
        }
      }
    }
  }
  function createTrackingSender() {
    var trackingImg = document.createElement('img');
    trackingImg.width = '0px';
    trackingImg.height = '0px';
    trackingImg.style = 'display:none';
    document.body.appendChild(trackingImg);
    return trackingImg;
  }
  var util = {
    track: track
  };
  function getVideoEventUrlByEvnt(event) {
    if (config.track !== undefined) {
      var adid = config.track.adid ? config.track.adid : '';
      var bid = config.track.bid ? config.track.bid : templateSearchParams.has(TPL_PARAMS.LICENSE_KEY) ? templateSearchParams.get(TPL_PARAMS.LICENSE_KEY) : '';
      var uid = config.track.uid ? config.track.uid : templateSearchParams.has(TPL_PARAMS.UID) ? templateSearchParams.get(TPL_PARAMS.UID) : '';
      var vpadnSid = templateSearchParams.has(TPL_PARAMS.SESSION_ID) ? templateSearchParams.get(TPL_PARAMS.SESSION_ID) : '';
      var vpadnSeq = templateSearchParams.has(TPL_PARAMS.SEQUENCE_ID) ? templateSearchParams.get(TPL_PARAMS.SEQUENCE_ID) : '';
      var clid = '1.' + bid + '.' + vpadnSid + '.' + vpadnSeq;
      var vid_tid = config.track.trackid ? config.track.trackid : templateSearchParams.has(TPL_PARAMS.VIDEO_TRACKING_ID) ? templateSearchParams.get(TPL_PARAMS.VIDEO_TRACKING_ID) : '';
      var e = config.track.e ? config.track.e : templateSearchParams.has(TPL_PARAMS.PARAM_E) ? templateSearchParams.get(TPL_PARAMS.PARAM_E) : '';
      var _eventMapping;
      switch (event) {
        case 'start':
          _eventMapping = '__vpad_a_start';
          break;
        case 'firstQuartile':
          _eventMapping = '__vpad_a_firstquartile';
          break;
        case 'midpoint':
          _eventMapping = '__vpad_a_midpoint';
          break;
        case 'thirdQuartile':
          _eventMapping = '__vpad_a_thirdquartile';
          break;
        case 'complete':
          _eventMapping = '__vpad_a_complete';
          break;
        case 'replay':
          _eventMapping = '__vpad_a_replay';
          break;
        case 'link':
          _eventMapping = '__vpad_a_link';
          break;
        case 'changemute':
          _eventMapping = '__vpad_a_changemute';
          break;
        case 'progress':
          _eventMapping = '__vpad_a_progress';
          break;
        case 'play':
          _eventMapping = '__vpad_a_play';
          break;
        case 'pause':
          _eventMapping = '__vpad_a_pause';
          break;
      }
      var videoEventUrl = new URL(VIDEO_EVENT_URL);
      var baseVideoEventParams = new URLSearchParams({
        t: 'event',
        tid: vid_tid,
        ec: '__vpad_c_vid',
        el: vid_tid,
        clid: clid,
        ad: adid,
        uid: uid,
        e: e
      });
      videoEventUrl.search = baseVideoEventParams;
      videoEventUrl.searchParams.append('ea', _eventMapping);
      VponConsole('log', videoEventUrl.toString());
      return videoEventUrl.toString();
    } else {
      return "";
    }
  }
  var trackingUrl = {
    "start": [getVideoEventUrlByEvnt('start')],
    "firstQuartile": [getVideoEventUrlByEvnt('firstQuartile')],
    "midpoint": [getVideoEventUrlByEvnt('midpoint')],
    "thirdQuartile": [getVideoEventUrlByEvnt('thirdQuartile')],
    "complete": [getVideoEventUrlByEvnt('complete')],
    "replay": [getVideoEventUrlByEvnt('replay')],
    "link": [getVideoEventUrlByEvnt('link')],
    "changemute": [getVideoEventUrlByEvnt('changemute')],
    "progress": [getVideoEventUrlByEvnt('progress')],
    "play": [getVideoEventUrlByEvnt('play')],
    "pause": [getVideoEventUrlByEvnt('pause')]
  };
  function setTrackingTimes(videoTotalTime) {
    trackingTimesArray = [];
    trackingTimes['start'] = {
      time: digitSet(Math.floor(videoTotalTime * (4 / 4))),
      tag: 'videoStart'
    };
    trackingTimesArray.push(trackingTimes['start']);
    trackingTimes['first'] = {
      time: digitSet(Math.floor(videoTotalTime * (3 / 4))),
      tag: 'videoFirst'
    };
    trackingTimesArray.push(trackingTimes['first']);
    trackingTimes['mid'] = {
      time: digitSet(Math.floor(videoTotalTime * (2 / 4))),
      tag: 'videoMid'
    };
    trackingTimesArray.push(trackingTimes['mid']);
    trackingTimes['third'] = {
      time: digitSet(Math.floor(videoTotalTime * (1 / 4))),
      tag: 'videoThird'
    };
    trackingTimesArray.push(trackingTimes['third']);
    trackingTimes['end'] = {
      time: digitSet(Math.floor(videoTotalTime * (0 / 4))),
      tag: 'videoEnd'
    };
    trackingTimesArray.push(trackingTimes['end']);
    var progress = config.track && config.track.progress ? config.track.progress : templateSearchParams.get(TPL_PARAMS.PROGRESS);
    if (progress && progressValidate(progress, videoTotalTime)) {
      trackingTimes['progress'] = {
        time: digitSet(progressValidate(progress, videoTotalTime)),
        tag: 'progress'
      };
      trackingTimesArray.push(trackingTimes['progress']);
    } else {
      trackingTimes['progress'] = {
        time: null,
        tag: 'progress'
      };
      VponConsole('warn', '[VponVideo] no have progress');
    }
  }

  /**
   * 驗證progress參數格式
   * @param {string} progress - 擷取progress參數
   * @param {number} videoTotalTime - 影片總長度(單位：秒)
   */
  function progressValidate(progress, videoTotalTime) {
    var time = null;
    if (!progress) {
      return false;
    }
    if (progress.indexOf('%') !== -1) {
      //格式為百分比
      if (isNaN(parseFloat(progress))) {
        return false;
      }
      time = parseFloat(progress) < 0 ? String(videoTotalTime) : parseFloat(progress) > 100 ? '0' : String(videoTotalTime - videoTotalTime * parseFloat(progress) / 100);
    } else {
      //格式為時：分：秒
      var progressTimeArr = progress.split(':');
      var progressTime = videoTotalTime - (parseFloat(progressTimeArr[0]) * 3600 + parseFloat(progressTimeArr[1]) * 60 + parseFloat(progressTimeArr[2]));
      if (isNaN(progressTime)) {
        return false;
      }
      time = progressTime < 0 ? '0' : progressTime > videoTotalTime ? String(videoTotalTime) : String(progressTime);
    }
    return time;
  }
  var MoatApiReference;
  if (window.support && typeof support.isInWeb === 'function' && support.isInWeb()) {
    this.initialMoat = function (ids, duration, partnerCode) {
      var video_area = typeof videoContainer === 'string' ? document.querySelector("#".concat(videoContainer)) : videoContainer;
      var c = video_area;
      var l = config.src;
      MoatApiReference = initMoatTracking(ids, duration, partnerCode);
      function initMoatTracking(d, e, k) {
        var g = document.createElement("script"),
          a = [];
        d = {
          adData: {
            ids: d,
            duration: e,
            url: l
          },
          dispatchEvent: function dispatchEvent(b) {
            this.sendEvent ? (a && (a.push(b), b = a, a = !1), this.sendEvent(b)) : a.push(b);
          }
        };
        e = "_moatApi" + Math.floor(1E8 * Math.random());
        var f, h;
        try {
          f = c.ownerDocument, h = f.defaultView || f.parentWindow;
        } catch (b) {
          f = document, h = window;
        }
        h[e] = d;
        g.type = "text/javascript";
        c && c.insertBefore(g, c.childNodes[0] || null);
        g.src = "https://z.moatads.com/" + k + "/moatvideo.js#" + e;
        return d;
      }
      ;
    };
  }
  function triggerMoatEvent(eventType) {
    var adVolume = Math.floor(video.volume);
    if (video.muted === true) {
      adVolume = 0;
    }
    var videoEvent = {
      type: eventType,
      adVolume: adVolume
    };
    if (MoatApiReference === undefined) {
      return;
    }
    MoatApiReference.dispatchEvent(videoEvent);
  }

  // 在 OM SDK 架構下，打出 Impression, start, firstQuartile... 等等四分位報表時的 callback，告知 Native 已經打出 Tracking
  function fireOMEventOccur(deviceType, eventType, sessionId) {
    switch (deviceType) {
      case 'a':
        _vpon_android.omEventOccur(JSON.stringify({
          eventType: eventType,
          sessionId: sessionId
        }));
        break;
      case 'i':
        window.webkit.messageHandlers.omEventOccur.postMessage(JSON.stringify({
          eventType: eventType,
          sessionId: sessionId
        }));
        break;
      default:
        VponConsole('log', '[VponVideo] Can not parse arguments of device type.');
    }
  }
  var viewableDetectionListener = function viewableDetectionListener() {
    var options = {
      root: null,
      rootMargin: '0px',
      threshold: [0.5, 1]
    };
    var callback = function callback(entries) {
      entries.forEach(function (entry) {
        var viewPercent = parseInt(entry.intersectionRatio * 100);
        for (var _i2 = 0, _listeners = listeners; _i2 < _listeners.length; _i2++) {
          var listener = _listeners[_i2];
          listener(viewPercent);
        }
      });
      listenDOM.unobserve(document.querySelector('body'));
    };
    var listenDOM = new IntersectionObserver(callback, options);
    listenDOM.observe(document.querySelector('body'));
  };
  function sendVideoTracking(eventsLister, videoLeftTime) {
    var stateArr = checkVideoTimeState(videoLeftTime);
    stateArr.forEach(function (item) {
      if (isSendTrackingEventArr.indexOf(item) === -1) {
        isSendTrackingEventArr.push(item);
        switch (item) {
          case 'videoStart':
            var muted = video.muted ? 0 : 1;
            if (config.track && Object.keys(config.track).length !== 0) {
              sendQuartileTracking(trackingUrl.start);
            }
            customTracking(eventsLister, 'quartileTracking', 0);
            triggerMoatEvent('AdVideoStart');
            try {
              viewableDetectionListener();
              if (window.vponOMIDBridge !== undefined && window.vponOMIDBridge.videoEvents !== undefined) {
                VponConsole('log', '[VponVideo] fire vponOMIDBridge.videoEvents.start & vponOMIDBridge.adEvents.impressionOccurred()');
                window.vponOMIDBridge.videoEvents.start(video.duration, muted);
                window.vponOMIDBridge.adEvents.impressionOccurred();
                if (vponOMIDBridge.isSupportOMEventOccur !== undefined && vponOMIDBridge.isSupportOMEventOccur) {
                  VponConsole('warm', '[VponVideo] fire omEventOccur.');
                  fireOMEventOccur(vponOMIDBridge.deviceType, 'impression', vponOMIDBridge.sessionId);
                  fireOMEventOccur(vponOMIDBridge.deviceType, 'start', vponOMIDBridge.sessionId);
                }
              }
            } catch (error) {
              VponConsole('warn', error);
            }
            break;
          case 'videoFirst':
            if (config.track && Object.keys(config.track).length !== 0) {
              sendQuartileTracking(trackingUrl.firstQuartile);
            }
            customTracking(eventsLister, 'quartileTracking', 1);
            triggerMoatEvent('AdVideoFirstQuartile');
            try {
              if (window.vponOMIDBridge !== undefined && window.vponOMIDBridge.videoEvents !== undefined) {
                VponConsole('log', '[VponVideo] fire vponOMIDBridge.videoEvents.firstQuartile()');
                window.vponOMIDBridge.videoEvents.firstQuartile();
                if (vponOMIDBridge.isSupportOMEventOccur !== undefined && vponOMIDBridge.isSupportOMEventOccur) {
                  VponConsole('warn', '[VponVideo] fire omEventOccur.');
                  fireOMEventOccur(vponOMIDBridge.deviceType, 'firstQuartile', vponOMIDBridge.sessionId);
                }
              }
            } catch (error) {
              VponConsole('warn', error);
            }
            break;
          case 'videoMid':
            if (config.track && Object.keys(config.track).length !== 0) {
              sendQuartileTracking(trackingUrl.midpoint);
            }
            customTracking(eventsLister, 'quartileTracking', 2);
            triggerMoatEvent('AdVideoMidpoint');
            try {
              if (window.vponOMIDBridge !== undefined && window.vponOMIDBridge.videoEvents !== undefined) {
                VponConsole('log', '[VponVideo] fire vponOMIDBridge.videoEvents.midpoint()');
                window.vponOMIDBridge.videoEvents.midpoint();
                if (vponOMIDBridge.isSupportOMEventOccur !== undefined && vponOMIDBridge.isSupportOMEventOccur) {
                  VponConsole('warn', '[VponVideo] fire omEventOccur.');
                  fireOMEventOccur(vponOMIDBridge.deviceType, 'midpoint', vponOMIDBridge.sessionId);
                }
              }
            } catch (error) {
              VponConsole('warn', error);
            }
            break;
          case 'videoThird':
            if (config.track && Object.keys(config.track).length !== 0) {
              sendQuartileTracking(trackingUrl.thirdQuartile);
            }
            customTracking(eventsLister, 'quartileTracking', 3);
            triggerMoatEvent('AdVideoThirdQuartile');
            try {
              if (window.vponOMIDBridge !== undefined && window.vponOMIDBridge.videoEvents !== undefined) {
                VponConsole('log', '[VponVideo] fire vponOMIDBridge.videoEvents.thirdQuartile()');
                window.vponOMIDBridge.videoEvents.thirdQuartile();
                if (vponOMIDBridge.isSupportOMEventOccur !== undefined && vponOMIDBridge.isSupportOMEventOccur) {
                  VponConsole('warn', '[VponVideo] fire omEventOccur.');
                  fireOMEventOccur(vponOMIDBridge.deviceType, 'thirdQuartile', vponOMIDBridge.sessionId);
                }
              }
            } catch (error) {
              VponConsole('warn', error);
            }
            break;
          case 'videoEnd':
            if (config.track && Object.keys(config.track).length !== 0) {
              sendQuartileTracking(trackingUrl.complete);
            }
            customTracking(eventsLister, 'quartileTracking', 4);
            triggerMoatEvent('AdVideoComplete');
            try {
              if (window.vponOMIDBridge !== undefined && window.vponOMIDBridge.videoEvents !== undefined) {
                VponConsole('log', '[VponVideo] fire vponOMIDBridge.videoEvents.complete()');
                window.vponOMIDBridge.videoEvents.complete();
                if (vponOMIDBridge.isSupportOMEventOccur !== undefined && vponOMIDBridge.isSupportOMEventOccur) {
                  VponConsole('warn', '[VponVideo] fire omEventOccur.');
                  fireOMEventOccur(vponOMIDBridge.deviceType, 'complete', vponOMIDBridge.sessionId);
                }
              }
            } catch (error) {
              VponConsole('warn', error);
            }
            break;
          case 'progress':
            if (config.track && Object.keys(config.track).length !== 0) {
              sendQuartileTracking(trackingUrl.progress);
            }
            break;
          case 'play':
            eventMapping = '__vpad_a_play';
            break;
          case 'pause':
            eventMapping = '__vpad_a_pause';
            break;
        }
      }
    });
  }
  function checkVideoTimeState(videoLeftTime) {
    var stateArr = [];
    if (Object.keys(trackingTimes).length === 0) {
      return;
    }
    if (videoLeftTime == trackingTimes['start'].time) {
      stateArr.push(trackingTimes['start'].tag);
    }
    if (videoLeftTime == trackingTimes['first'].time) {
      stateArr.push(trackingTimes['first'].tag);
    }
    if (videoLeftTime == trackingTimes['mid'].time) {
      stateArr.push(trackingTimes['mid'].tag);
    }
    if (videoLeftTime == trackingTimes['third'].time) {
      stateArr.push(trackingTimes['third'].tag);
    }
    if (videoLeftTime == trackingTimes['end'].time) {
      stateArr.push(trackingTimes['end'].tag);
    }
    if (videoLeftTime == trackingTimes['progress'].time) {
      stateArr.push(trackingTimes['progress'].tag);
    }
    return stateArr;
  }
  var handleTimeUpdate = function () {
    var currentTime;
    return function () {
      if (video.currentTime === 0 || video.duration === NaN) {
        return;
      }
      var videoLeftTime = video.duration - video.currentTime;
      if (isDifferentTime(currentTime)) {
        updateCountdown(videoLeftTime);
        setVponVideoControls();
        var stateArr = checkVideoTimeState(videoLeftTime);
        if (stateArr.indexOf('videoStart') !== -1) {} else if (stateArr.indexOf('videoEnd') !== -1) {
          isPlaying = false;
          video.currentTime = video.duration;
          showVponVideoReplayControls();
        }
      }
      currentTime = videoLeftTime;
    };
  }();
  function isDifferentTime(curr) {
    return curr !== Math.floor(video.duration - video.currentTime) ? true : false;
  }
  function customCreateElement(dom, id) {
    var customDOM = document.createElement(dom);
    customDOM.setAttribute('id', id);
    return customDOM;
  }
  var videoTimeSpan = customCreateElement('span', 'countdownTime');
  videoTimeSpan.setAttribute('id', 'countdownTime');
  videoTimeSpan.style.position = 'absolute';
  videoTimeSpan.style[config.countdownPosition === 'top' ? 'top' : 'bottom'] = '15px';
  videoTimeSpan.style.left = '15px';
  videoTimeSpan.style.fontSize = '17px';
  videoTimeSpan.style.color = '#fff';
  videoTimeSpan.style.display = config.countdownHidden ? 'none' : 'block';
  function updateCountdown(videoLeftTime) {
    video.parentElement.appendChild(videoTimeSpan);
    var countdownTime = document.querySelector('#countdownTime');
    if (document.querySelector('iframe[class^="Vpon__flrec"]')) {
      countdownTime = document.querySelector('iframe[class^="Vpon__flrec"]').contentDocument.querySelector('#countdownTime');
    }
    var min = digitSet(Math.floor(videoLeftTime / 60));
    var sec = digitSet(Math.floor(videoLeftTime % 60));
    if (isNaN(min) || isNaN(sec)) {
      return;
    }
    countdownTime.innerText = min + ":" + sec;
  }
  var replayButton = customCreateElement('img', 'replayButton');
  replayButton.style.zIndex = 2;
  replayButton.setAttribute('aria-label', systemVar.ariaLabel.replay_button);
  var otherLink = customCreateElement('span', 'otherLink');
  function setVponVideoControls() {
    var replayIcon = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKAAAACgCAMAAAC8EZcfAAAA21BMVEUAAAAAAACjo6MAAAAAAAAAAAAAAAAGBgYDAwOvr6+6urrFxcX+/v6Tk5P7+/v6+vrNzc2Hh4fi4uLt7e339/eysrLk5OTg4ODp6em/v7+4uLj29vbp6ena2tp8fHzT09PX19cAAADQ0NCWlpbw8PDCwsLf39+tra28vLzOzs7GxsYuLi7x8fHX19fb29ttbW1KSkq/v7+lpaVQUFDKysqxsbHy8vLLy8vq6uqkpKTDw8NiYmKKioqlpaULCwuwsLAxMTGTk5O0tLSdnZ3p6eng4OBubm5kZGT////H7vHqAAAASHRSTlMACpwRIy8aOUCYlI/6offyjafB5uqq29bGs7Dk4c9oycxLv3Xrvrihi6WbTtO1rF5Vl4JJwYvdu9GlclBFeFpbQ63AuKyOezjfeLCKAAALm0lEQVR42u2cCVfaQBSFm7Q0AYFUNtmkFBRRrPvWaveN//+LineS3FmikHRQeg7X0/bUVvi8783My5sZX6y11lprrWVZzuxjReUIuPtfzgpyCix+rBgknFthwpgnFPlWApHRlbVSJpLvZSQwrggiHASdqlUiBKDAeg2R8fkzMY4u6KiY8NlNFIQh3qtI939ZEROBB75XHw/LQfNLLhczroCJeO+Q79cUap7ncgJSMfGJRbrYvy/FqVD5o0fE5zPRkfiQfD+nsSrnnicQnykTnQS+XGdKBZ98BfFp50RHWzsEXw4R3g1CxNEEiE9vIuk4+d3j5TxwbX5rhIS1oe/DRBIu3ULTPNgn+HwBWCrtlgVh8UgycbkeEo90Op7/DlSlmT50p0KdXoKJ5Fuie4BDcMkXAkIXkYn7PkxUw0wt0T3QEW/G9xlIrlC9OhW6gokI83ITkamn0eW8e/tmfASE3hZDEw9IyDx8AjzQwT3g/f5dEoB56N7EnanQ4TEIlQlxSXzEo3l+rzC4CaaRgBcy9iMTT3VC69mn2CfRHRcqYjgQsCAExHZtKnRzC0IC2jfQwPP9k4Pq1FAhFkzcCk0sjz3ZQsp2TcBp76yJ904A3NjYiBBdtwUTUYQtw0L6p83Klx2Vq1jrXB3eNJvNjUghIU0MvsBCDGSbdGp4Bd64NqXK3f51Oy9yj3ggFMO5FYTfxEdYaNlBRympMDSGHRq302/NEPIK35s3byIPAVhyG+G3chfF2L5/tO+kwqJvu+4CT+Z7AymApdJ3YeIRAG066Bh8hXhaqc68S+LTCAG4+a2LCowOLsU/z580o9h2224yXzLg5jd8FR207N8rwderRe4BD3w64PIdpIE63ziadS+IR0CV8Aly0ODbnwptfXBjQDrIMfzgKC7eWZwHHXzI+fc+tG/XJR8dFIRU8jwIQDsOGnzh7LJTdxX/3BDxdP/9qCKtJIXElYQp6NhJQPI1w/ASjw7ub1XjySe0MWktfmXZQPIxvttki/4cVIsLVTOsqQFoLQHl8VF860JErG/BOgPQrAdZDtozkHxjwXehuVdv0LxHK+qNnF5QOxYT0PN74o3gHxn3FLxidVsBVJ5JyLcUAyc15h81YHCDSv7354ef6mw3F2igMsE0Yu9gXzW2bjR8J/TAc7HMZ9FABrgg5j+X4tw7DQ4mPhR3FtyZSoO4s2C2j+hfVjo1wCd4r3JdCW80eWx4kWaISb2ZhAacTQMZ4F0GmOlVOUGTEvK8GJDdLaWFSf9sGugPzQVkO7Tvk8CLmwxGf1CzT7y0bQM7YPkg+xe+fw/+RDI7rF9N+6yIBnKEXJj5d3juRX38mYCo9qiJR/usVTE0EFNgVfKvJfhG0egEARjlLn/zHHiaffYqfScy8BLJ3qZ/eyKC75leEBilfRLQ2baPDyJaBnZdqiviK7UkJcRop+kPd8KsjV4GWFpE/DO8YZsRHojxca5Mvmy6ir06biVatY+IHCJNZiC0V0bIe+xUUXGkIe4Xm/Y58sc/zTEnSKoWAbdg4Jnc6zOOA1CObt+/nw0hIAw8xYTBALcBPJL5jH0d4pFv7ukaJ1UKMsJXWpXVwBA9J594+RgREmzz8KBMJnIM+8cIKKuEOgzcmBlo9Pn4xjEc6fX4UjJkhggXpDIrH2VggAALPi23VE/M7EvKVokxPSDqmD4jjCF84DEB+b6qPcnvh08/fHolXQpilgYQV5FrZODXyEAtv5RIC3QjusRTJiMSpkvBHoAY4S6GsGYgpQM7D7e6qZSVNhzkJKPN0hgiQ88wkKKD5j8YG0FCQBSEToqFGIDv1RRsYYhwCKdbvpSdjLtfh0ExOPx1B8SYMO0YuUH9qdbRldhAJyUdW7V/fkZVT/Hnn1SEBMQYCdRZEM+RYwJmq4Jn9tWmVO1OJlxEHMQTfI+sVDGmjxnhjL3Qu2AqK7iV9mmd9IO4xkIGvEhB8XIZe41XU1VXLIwWi3EMOMQgVsdIR0rBbDXSOGyT/dj8ET68jrmyL+wgi9WGOk03M6YgWykdxPXH5r1+INqddFmjPY404hQccJrONkZEBsK075tC3/G329jChR1kqbDFZhW2EbIBcvb6iPpjMxIadB8JmMrBA7UY7E9n2pcBsxSZb/Bdx4BbqN/iGC+01tkENB8j9tEI3SxBm5t40QOUH+kdZIjzNkIsXvYIgKCb/QodxIumd5CDxP3XQcIFdIRGCvDuf8MzxKWXzUFMM11tmjG/2XTrUxPre6nkliAAnhFwEQcXnagzGSjOQLbv2YCI9X2Y0kFzqcsrS12GlYSJg8XDFW3imVA39FI7+BKALBYgtVhIxccXPUaRDj4QgneSzkHr5ZYjhWUcpw0A61j3fCmxbRasWXoV6nNiaRe7ZARcbKmbW/JzXUr9oBgovZ5SH63GNA6CMOGhKc+HplxaCx1WSEM1rcUgPk3jIPOFj52xutpU7aTtN3ojTq0cdz0/Rb0FB+c9uHNpT9nO+4oXvHYjtfGCPrNmMQcXbH2AMNWei3fAkLD+qPhSTDI2j6A5zaNkqbuSgbYlhGqwkGoQczV+rP0mty8X37f3NjBE6vGGeB0vf+ynG3YOk3B+A3M+Ifly52WWR5xYr/z0E5fZAobiFnCFQX6M0NECXNG3XAJ1klncQcaYTXRaONMnb4Ezx+gG8WCa92mqGdgC8IkU4bTF24PbEMFtjoRAnH9w7hZ+lfdcdW1vZokwxzE3ciINuNH0KKGj8XmH+MKBlC5iRyPNGCbi3K2win5/AEDJp8KZgOYLdXy289K10edtJh5Jm3Va75x8PDh3JBpFe/p4uwwNzFoecTuWahVJCBNNRu7dKXzFlqtlYG3Gl6aSYYTmbmgjykQEI6XdhakIvoFLXeBThUwGcirUjgSwCQId3oYmAtHQ68i+28OpcW7pQ5kZmP4Zx5Gz8JFDFcFsPuSpABWOV3U+BTw3p21KDjMbSAulYykUj6WcAxGMlHxV5xxfrZ+b2xVf7St1R9aTW75ysCevH+zhyRSKt002ytM4/6i6eEUsIhkN5FxoHo3Ka0ejvno5SIYD3teD+D+1XFk78QhhKZ2pJ28eLqP2uvFdg9HQEz5Ss08MR/AJ8/OeK6uhBjhLO5SFOoK8wPG88bEn6XhcYS+/jPDqQ6w2QYBpYDppQeYBR+ahccCx0xwd7e8fjZod5dMN2KdPUsVelgAT79EjooRsE1EV8dr8CugibO0zwORLPVCSD9lSPGSbrPJWnXTKBLUv8c1k/ZhyXn7T624x0bwuny/V/EMzwUjA7BZyKHMsa2ptV8uKddXtFrNBHr9Qxc4tOwYZS552VD6vv/le63rwtt9/O7hucVgoiPWdiM/3/vHUNy1kGhqXDUhHmWT8T7vlOL76JcDsFpIw6boGIebrA+qDcHxofFnxtKGcfOHlEefy0r/H943HCh8A/41xzpUhHSnZ0HY12r/u2bzJy9YFCScV49KV6SPNE3jxPFSZkE9NQHseJlxbIxPBqFY1nnwKvlX/6OGci3+PqL7NoqFywvv4dg6l00OVEFcnI+30GWpN7f4O/1+HP3TB8qF+xcMIsVBT1o3+bl1zbrevrC21Qohn1z8SatdjE6/vVruNre3trUa3WtMW587lDI/26f5ZzEOayAvQ81RsnkV4KS5FZF/2ZMST06t5eFenJxLecn5MgNkNIiIv4SeoXCkc+8SjffTPMqWOKBj93un7m0BlC27en/Z8QWfggc86HU0kIhgFpD/pDc8uCwcHhcuzYW/iAw50xFuKfSTUEMkISFBSHuBIZ/TAqGX/LBJAkpNkgEvEo6wTEpE9Io2SbOwqqXjLReSAJiMgTeGf9MPIy8IjIRhpIyBDSWSEo3lLxjNdJCMxiUY6mrdkPhKSkZCUAZci96wzghIy0Ej3ZOaZjPygSPZ8dCYjiYj8rHRkhB68ZbMSP+Z0BvO//FTgZ/9hl2uttdZaa62l6y/egSwVjhCPdwAAAABJRU5ErkJggg==';
    replayButton.src = replayIcon;
    replayButton.style.position = 'absolute';
    replayButton.style.top = '50%';
    replayButton.style.left = '50%';
    replayButton.style.transform = 'translate(-50%, -50%)';
    replayButton.style.width = '60px';
    replayButton.style.display = 'none';
    video.parentElement.appendChild(replayButton);
    replayButton.addEventListener('click', replayVideo);
    otherLink.style.position = 'absolute';
    otherLink.style.color = '#fff';
    otherLink.style.fontSize = '17px';
    otherLink.style.top = '15px';
    otherLink.style.right = '15px';
    otherLink.innerText = templateSearchParams.has(TPL_PARAMS.VIDEO_FUNCTION_1_DESC) ? templateSearchParams.get(TPL_PARAMS.VIDEO_FUNCTION_1_DESC) : '';
    otherLink.style.display = 'none';
    video.parentElement.appendChild(otherLink);
    otherLink.addEventListener('click', openOtherLink);
  }
  function showVponVideoReplayControls() {
    replayButton.style.display = "block";
    otherLink.style.display = "block";
  }
  function replayVideo(e) {
    e.stopPropagation();
    if (window.vponOMIDBridge !== undefined && window.vponOMIDBridge.videoEvents !== undefined) {
      VponConsole('log', '[VponVideo] fire vponOMIDBridge.videoEvents.resume()');
      window.vponOMIDBridge.videoEvents.resume();
      if (vponOMIDBridge.isSupportOMEventOccur !== undefined && vponOMIDBridge.isSupportOMEventOccur) {
        VponConsole('warn', '[VponVideo] fire omEventOccur.');
        fireOMEventOccur(vponOMIDBridge.deviceType, 'resume', vponOMIDBridge.sessionId);
      }
    }
    video.currentTime = 0;
    replayButton.style.display = "none";
    video.play();
  }
  function openOtherLink(e) {
    var clickUrl = templateSearchParams.get(TPL_PARAMS.W_F_1_A);
    clickUrl = clickUrl.replace(/\[.*?\]/g, -1);
    if (e) {
      clickUrl = clickUrl.replace('clk_x=-1&clk_y=-1', "clk_x=".concat(e.clientX, "&clk_y=").concat(e.clientY));
    }
    if (window.support) {
      if (e) {
        support.click(e);
      } else {
        support.click();
      }
      support.open(clickUrl);
    }
  }
  video.addEventListener('playing', function () {
    var executed = false;
    return function () {
      if (!executed) {
        setTrackingTimes(Math.floor(video.duration));
        executed = true;
        isPlaying = true;
      }
    };
  }(), false);
  video.addEventListener('timeupdate', handleTimeUpdateFunc);
  video.addEventListener('volumechange', function (e) {
    try {
      VponConsole('log', '[VponVideo] in volume change listener, ready to fire event');
      if (window.vponOMIDBridge !== undefined && window.vponOMIDBridge.videoEvents !== undefined) {
        VponConsole('log', '[VponVideo] fire volumechange event');
        var muted = video.muted ? 0 : 1;
        window.vponOMIDBridge.videoEvents.volumeChange(muted);
      }
    } catch (error) {
      VponConsole('warn', error);
    }
  });
});
window.VponVideo = VponVideo;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(2),
  verifyCtid = _require.verifyCtid;
var _require2 = __webpack_require__(1),
  parseCtidToObj = _require2.parseCtidToObj,
  generateUID = _require2.generateUID;
var SDK_NAME = "j",
  SDK_VERSION = "1.2.0",
  // window.Vpadn global namespace
  VPADN,
  // Debug status (default 0) Vpadn('create', License_Key, {'debug': true});
  DEBUG,
  // Key based on client's id Vpadn('create', License_Key);
  KEY,
  // Encoding (default document.characterSet | charset) Vpadn('create', License_Key, {'encoding': 'UTF-8'})
  // ENCODING,

  // Vpadn unique client ID (cookie use)
  CTID_NAME = "vpadn-ctid",
  // Vpadn unique client ID (url parameter use)
  CTID_URL_PARAM_NAME = "_vpctid",
  // Vpadn session ID (lk-value)
  SEID_NAME = "vpadn-seid",
  // CTID and SEID set in create event
  ISNEW_CTID,
  CTID_LIFE = 730,
  // 2 years - 2*365 days
  CTID,
  SEID_LIFE = 30 / (24 * 60),
  // 30 minutes - 30/(24*60) days
  SEID,
  // Cookie Domain
  COOKIE_DOMAIN,
  // Document Referrer
  DOCUMENT_REFERRER = document.referrer,
  // Data Parameter from ADNetwork and DSP
  GAID,
  IDFA,
  CLICK_ID,
  SRC,
  VPID_KEY = "vpadn-vpid",
  JSON_KEY = "vponId",
  JSON_THIRDPARTY_KEY = "ce",
  // the last cookie sync date
  LAST_COOKIE_SYNC = "vpadn-sd",
  //cookie expired in 7 days
  COOKIE_LIFE_DAY = 7,
  THIRD_COOKIE_ENABLED_FLAG = "vpadn-ce";
var secure = window.location.protocol === "https:";

// var ET_HOST = (secure ? 'https' : 'http') + '://tags-dmp.vpadn.com/',
var DMP_HOST = (secure ? "https" : "http") + "://ids-dmp.vpadn.com/",
  protocolName = {
    0: "create"
    // 1: 'mapUser',
    // // others mean event/payload
    // 999: 'others'
  },
  protocol = [];

// different protocol with different url
protocol[protocolName[0]] = DMP_HOST + "set"; // drop client cookie
// protocol[protocolName[1]] = DMP_HOST + 'map'; // cokie sync
// protocol[protocolName[999]] = ET_HOST + 'et'; // event tracking

var urlEncodeComponent = window.encodeURIComponent;
var urlDecodeComponent = window.decodeURIComponent;
var cookie = {
  write: function write(name, value, days, domain, path) {
    var date = new Date();
    days = days || 730; // two years
    path = path || "/";
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    var expires = "; expires=" + date.toGMTString();
    var cookieValue = "".concat(name, "=").concat(value).concat(expires, "; path=").concat(path, "; SameSite=None; Secure");
    if (domain) {
      cookieValue += "; domain=" + domain;
    }
    document.cookie = cookieValue;
  },
  read: function read(name) {
    var allCookie = "" + document.cookie;
    var index = allCookie.indexOf(name);
    if (name === undefined || name === "" || index === -1) return "";
    var ind1 = allCookie.indexOf(";", index);
    if (ind1 == -1) ind1 = allCookie.length;
    return unescape(allCookie.substring(index + name.length + 1, ind1));
  },
  remove: function remove(name) {
    if (this.read(name)) {
      this.write(name, "", -1, "/");
    }
  }
};
var getUrlParameterByName = function getUrlParameterByName(name, url) {
  // http://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)", "i"),
    results = regex.exec(url);
  return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
};
var generateSEID = function generateSEID(key) {
  // <license_key>-<timestamp> 11429772959540-14297738918
  return key + "-" + Math.floor(1 * new Date() / 100);
};
var testCanWriteCookies = function testCanWriteCookies(domain) {
  // https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cookies.js
  try {
    // Create cookie
    document.cookie = "cookietest=1" + (domain ? "; domain=" + domain : "");
    var ret = document.cookie.indexOf("cookietest=") != -1;
    // Delete cookie
    document.cookie = "cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT" + (domain ? "; domain=" + domain : "");
    return ret;
  } catch (e) {
    return false;
  }
};
var getTopReachableDomain = function getTopReachableDomain(url) {
  // default as current page url
  if (url === undefined) {
    url = location.href;
  }
  try {
    var hostname;
    if (window.URL) {
      hostname = new URL(url).hostname;
    }

    // double check
    if (hostname === undefined) {
      var parser = document.createElement("a");
      parser.href = url;
      hostname = parser.hostname;
    }

    // detect localhost
    if (hostname === "localhost") {
      return "";
    }
    var domainList = hostname.split("."),
      // ['www', 'vpon', 'com', 'tw']
      domainListLength = domainList.length,
      domain = domainList[domainListLength - 2] + "." + domainList[domainListLength - 1],
      current = domainListLength - 2;
    while (!testCanWriteCookies(domain) && current >= 0) {
      domain = domainList[--current] + "." + domain;
    }
    if (current < 0) {
      return false;
    }
    return domain;
  } catch (e) {
    return false;
  }
};
var sendBeaconAjax = function sendBeaconAjax(url, cb, errorCb) {
  var xmlHttp = new XMLHttpRequest();
  xmlHttp.timeout = 10000;
  xmlHttp.withCredentials = true;
  xmlHttp.onreadystatechange = function () {
    if (xmlHttp.readyState === 4 && xmlHttp.status === 200 && cb !== undefined) {
      cb(xmlHttp.responseText);
    } else if (xmlHttp.readyState === 4 && errorCb !== undefined) {
      errorCb(xmlHttp.responseText);
    }
  };
  xmlHttp.open("GET", url, true); // true for asynchronous
  xmlHttp.send();
};
var SetHelper = {
  setCallback: function setCallback(e) {
    var json = JSON.parse(e);
    if (json !== undefined && json[JSON_KEY] !== undefined) {
      // if (json[JSON_KEY] !== '0') {
      //     cookie.write(VPID_KEY, json[JSON_KEY], COOKIE_LIFE_DAY, COOKIE_DOMAIN);
      // }

      //if 3rd cookie setting failed, set a flag in 1st party cookie
      cookie.write(THIRD_COOKIE_ENABLED_FLAG, json[JSON_THIRDPARTY_KEY], COOKIE_LIFE_DAY, COOKIE_DOMAIN);
    }
  },
  setErrorCallback: function setErrorCallback(e) {}
};
var track = function track() {
  var arg = arguments,
    eventType = arg[0];
  if (eventType === "webSDK") {
    create.apply(this, arg);
  }
};
var create = function create() {
  var arg = arguments;
  COOKIE_DOMAIN = getTopReachableDomain();
  CTID = cookie.read(CTID_NAME) || window.localStorage && window.localStorage.getItem("vpadn-ctid") || generateUID();
  if (verifyCtid(CTID)) {
    CTID = "v1_".concat(CTID, ".").concat(new Date().getTime());
    window.localStorage && window.localStorage.setItem("vpadn-ctid", CTID);
  }
  cookie.write(CTID_NAME, CTID, CTID_LIFE, COOKIE_DOMAIN); // 1st party domain cookie

  // set SEID (sdk loaded)- !important, we have only one session, therefore we can use the global SEID name
  SEID = cookie.read(SEID_NAME);
  if (!SEID ||
  // check not exist
  getTopReachableDomain(DOCUMENT_REFERRER) !== COOKIE_DOMAIN ||
  // check different domain
  !new RegExp("^" + KEY).test(SEID)) {
    // check different license key
    SEID = generateSEID(KEY);
  }
  cookie.write(SEID_NAME, SEID, SEID_LIFE, COOKIE_DOMAIN); // 1st party domain cookie

  //20210105: TOC
  if (cookie.read(THIRD_COOKIE_ENABLED_FLAG) !== "0" && cookie.read(THIRD_COOKIE_ENABLED_FLAG) !== "1") {
    var ctidObj = parseCtidToObj(CTID);
    var ctid = ctidObj.ctid;
    sendBeaconAjax(protocol[protocolName[0]] + "?t=" + 1 * new Date() + "&dn=" + urlEncodeComponent(COOKIE_DOMAIN) + "&ctid=" + ctid, SetHelper.setCallback, SetHelper.setErrorCallback);
  }
};
var getCTID = function getCTID() {
  return CTID;
};

/**
 * find particular cookie value
 * @param {string} cookieName cookie name
 * @returns cookie value
 */
var getCookie = function getCookie(key) {
  if (typeof key !== "string") {
    console.warn("[Vpon-WebSDK] key must be string");
    return;
  }
  var cookies = document.cookie;
  var cookiesArr = cookies.split(";").map(function (item) {
    return item.trim();
  });
  var targetCookie = cookiesArr.find(function (cookie) {
    return cookie.split("=")[0] === key;
  });
  if (!targetCookie) {
    console.warn("[Vpon-WebSDK] Can't find key => ".concat(key));
    return;
  }
  return targetCookie.split("=")[1];
};
module.exports = {
  track: track,
  generateUID: generateUID,
  getCTID: getCTID,
  getCookie: getCookie,
  getTopReachableDomain: getTopReachableDomain
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.urlSearchParams = exports.isVponOMIDBridgeExist = exports.isElement = exports.digitSet = exports.assets = exports.VponConsole = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _require = __webpack_require__(1),
  isSDKiOS = _require.isSDKiOS;
var isElement = exports.isElement = function isElement(element) {
  try {
    return obj instanceof HTMLElement;
  } catch (e) {
    return (typeof obj === "undefined" ? "undefined" : _typeof(obj)) === "object" && obj.nodeType === 1 && _typeof(obj.style) === "object" && _typeof(obj.ownerDocument) === "object";
  }
};

/**
 * if env is in ios, send message to iOS developer
 * @param {String} type message type (log|warn|error)
 * @param {*} msg message
 */
var VponConsole = exports.VponConsole = function VponConsole(type, msg) {
  var typeMapping = ['debug', 'log', 'info', 'warn', 'error'];
  if (typeMapping.indexOf(type) !== -1) {
    console[type](msg);
  } else {
    VponConsole('warn', '[VponVideo] type is invalid');
  }
};
var urlSearch = window.location.search;
var urlSearchParams = exports.urlSearchParams = new URLSearchParams(urlSearch);
var assets = exports.assets = {
  iconMuteSrc: 'data:image/png;base64,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',
  iconUnmiteSrc: 'data:image/png;base64,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',
  videoPosterSrc: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAApsAAAF3AQMAAADQMhJDAAAABlBMVEX///////9VfPVsAAAACXBIWXMAAA7EAAAOxAGVKw4bAAADh0lEQVR4nO2YsW7bMBCGqQqwloBaMwhyH8GjBqN+FT2CxgxBrUfTA/QhWHToVmj0EITlHU+kLBm1GGcq/g+JIonmh6N4OtJRCgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwB0qOmTDjZabNzdR2Is7nm3vfq290lirVOluXtyH7HuKdE8fz6w1K2lBlx+Tfle1628yQxdXA973+cgnjSpSjI6L+uIG2auvLO1nLUdqJA5Kpzl9hLVc5XPpgb2OLlWaDxKUv1q0cmaoNlVacGwv09Wi1ctMspSP3ZVkIXWzlyidYvE8LVp3LO1TpdfvU7Vo5XHkD0qfb0rXj+UOrAnp2dySFslS1oT0PNyS7pKlrAnp2S1aeaL0egKTpO100vs/HOFTspRjCzlv6DDEmWNp9aB0EHMuUpY9J0tbOuzkwgfYTS+vJFyTLs3eSbo3LO1FUkor58Zh/VLcwexdedeZfaMLn1pVLIWdHFKl52JUuhjPLOVbOpRCX2xbJ/VnW/k5urqn9/4p+gkrQin0j9b5qpNNkf4a1DeljyqnUPyEuYfg1ya3fhGDky7W2Tv8plnR7rGRx7+N2SCDtaO/dGugycYE6R8arjZ+TiRzjKSpSHsnjYvDFn7QcJ8Gnz0yyZ2kacYPklKijsvYFi70+rgVmjuJtJnStBhUKGH1qus/pRlLSSjltAoCGr+8wynVb6RsLCUSkeow1CZKUzYpFAtLKRKp0UWYFAp/ly419KtFKjU6D+kzNaj1PmOztPX34jtJNyXPrnZEG6Qt9d2psPznQUpjrj4m7bT0F1kRhv8Z0sHfK8NKTabnx6TTylSH8kmm5nOkx5DoD0iniZr6vYScpDtdPH1EOgbBB6XUxVBkOuR3ZsKGjUztY1IZtaumZiY1nyJ11XTaU1HsJp5uhebWUBQ6lI4ybilnyZtSUBrKJJJWoXTUcZ2f5VmK9MjSYS49xopcLvZqG6loCqhjE+J7iWHpOEEpUj8/Zr65GaOpjqcpO5+Sf0b+8f2omoYXNkpTVlOXPzWNmFQy5yQkUxufxCFt3XcF+VW5nQ+txovvJq+KtiWFDzNph6LeaEUqh5NaSU99OYh0P9Dpds7W0D8h6B8Pi+8mhbW9zHphk3Z9quSP87Zp+YWHd8I6ngIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwH/FX4Ok7MIGd0maAAAAAElFTkSuQmCC'
};
var digitSet = exports.digitSet = function digitSet(num) {
  var strNum = num.toString();
  if (num < 0) {
    strNum = '00';
  }
  if (num < 10 && num >= 0) {
    strNum = '0' + num;
  }
  return strNum;
};
var isVponOMIDBridgeExist = exports.isVponOMIDBridgeExist = window.vponOMIDBridge !== undefined && window.vponOMIDBridge.videoEvents !== undefined;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// vpadn-video-sdk.js